(function (f) {
  if (typeof exports === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (typeof define === "function" && define.amd) {
    define([], f);
  } else {
    var g;
    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }
    (g.braintree || (g.braintree = {})).client = f();
  }
})(function () {
  var define, module, exports;
  return function () {
    function r(e, n, t) {
      function o(i, f) {
        if (!n[i]) {
          if (!e[i]) {
            var c = "function" == typeof require && require;
            if (!f && c) return c(i, !0);
            if (u) return u(i, !0);
            var a = new Error("Cannot find module '" + i + "'");
            throw a.code = "MODULE_NOT_FOUND", a;
          }
          var p = n[i] = {
            exports: {}
          };
          e[i][0].call(p.exports, function (r) {
            var n = e[i][1][r];
            return o(n || r);
          }, p, p.exports, r, e, n, t);
        }
        return n[i].exports;
      }
      for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) o(t[i]);
      return o;
    }
    return r;
  }()({
    1: [function (_dereq_, module, exports) {
      "use strict";

      var scriptPromiseCache = {};
      function loadScript(options) {
        var scriptLoadPromise;
        var stringifiedOptions = JSON.stringify(options);
        if (!options.forceScriptReload) {
          scriptLoadPromise = scriptPromiseCache[stringifiedOptions];
          if (scriptLoadPromise) {
            return scriptLoadPromise;
          }
        }
        var script = document.createElement("script");
        var attrs = options.dataAttributes || {};
        var container = options.container || document.head;
        script.src = options.src;
        script.id = options.id || "";
        script.async = true;
        if (options.type) {
          script.setAttribute("type", "".concat(options.type));
        }
        if (options.crossorigin) {
          script.setAttribute("crossorigin", "".concat(options.crossorigin));
        }
        Object.keys(attrs).forEach(function (key) {
          script.setAttribute("data-".concat(key), "".concat(attrs[key]));
        });
        scriptLoadPromise = new Promise(function (resolve, reject) {
          script.addEventListener("load", function () {
            resolve(script);
          });
          script.addEventListener("error", function () {
            reject(new Error("".concat(options.src, " failed to load.")));
          });
          script.addEventListener("abort", function () {
            reject(new Error("".concat(options.src, " has aborted.")));
          });
          container.appendChild(script);
        });
        scriptPromiseCache[stringifiedOptions] = scriptLoadPromise;
        return scriptLoadPromise;
      }
      loadScript.clearCache = function () {
        scriptPromiseCache = {};
      };
      module.exports = loadScript;
    }, {}],
    2: [function (_dereq_, module, exports) {
      module.exports = _dereq_("./dist/load-script");
    }, {
      "./dist/load-script": 1
    }],
    3: [function (_dereq_, module, exports) {
      "use strict";

      function uuid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0;
          var v = c === "x" ? r : r & 0x3 | 0x8;
          return v.toString(16);
        });
      }
      module.exports = uuid;
    }, {}],
    4: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      function deferred(fn) {
        return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          setTimeout(function () {
            try {
              fn.apply(void 0, args);
            } catch (err) {
              /* eslint-disable no-console */
              console.log("Error in callback function");
              console.log(err);
              /* eslint-enable no-console */
            }
          }, 1);
        };
      }
      exports.deferred = deferred;
    }, {}],
    5: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      function once(fn) {
        var called = false;
        return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          if (!called) {
            called = true;
            fn.apply(void 0, args);
          }
        };
      }
      exports.once = once;
    }, {}],
    6: [function (_dereq_, module, exports) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      /* eslint-disable consistent-return */
      function promiseOrCallback(promise, callback) {
        if (!callback) {
          return promise;
        }
        promise.then(function (data) {
          return callback(null, data);
        }).catch(function (err) {
          return callback(err);
        });
      }
      exports.promiseOrCallback = promiseOrCallback;
    }, {}],
    7: [function (_dereq_, module, exports) {
      "use strict";

      var deferred_1 = _dereq_("./lib/deferred");
      var once_1 = _dereq_("./lib/once");
      var promise_or_callback_1 = _dereq_("./lib/promise-or-callback");
      function wrapPromise(fn) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          var callback;
          var lastArg = args[args.length - 1];
          if (typeof lastArg === "function") {
            callback = args.pop();
            callback = once_1.once(deferred_1.deferred(callback));
          }
          // I know, I know, this looks bad. But it's a quirk of the library that
          // we need to allow passing the this context to the original function
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore: this has an implicit any
          return promise_or_callback_1.promiseOrCallback(fn.apply(this, args), callback); // eslint-disable-line no-invalid-this
        };
      }
      wrapPromise.wrapPrototype = function (target, options) {
        if (options === void 0) {
          options = {};
        }
        var ignoreMethods = options.ignoreMethods || [];
        var includePrivateMethods = options.transformPrivateMethods === true;
        var methods = Object.getOwnPropertyNames(target.prototype).filter(function (method) {
          var isNotPrivateMethod;
          var isNonConstructorFunction = method !== "constructor" && typeof target.prototype[method] === "function";
          var isNotAnIgnoredMethod = ignoreMethods.indexOf(method) === -1;
          if (includePrivateMethods) {
            isNotPrivateMethod = true;
          } else {
            isNotPrivateMethod = method.charAt(0) !== "_";
          }
          return isNonConstructorFunction && isNotPrivateMethod && isNotAnIgnoredMethod;
        });
        methods.forEach(function (method) {
          var original = target.prototype[method];
          target.prototype[method] = wrapPromise(original);
        });
        return target;
      };
      module.exports = wrapPromise;
    }, {
      "./lib/deferred": 4,
      "./lib/once": 5,
      "./lib/promise-or-callback": 6
    }],
    8: [function (_dereq_, module, exports) {
      (function (global, factory) {
        typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.loadAxo = {}));
      })(this, function (exports) {
        'use strict';

        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation.
          Permission to use, copy, modify, and/or distribute this software for any
        purpose with or without fee is hereby granted.
          THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
        REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
        AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
        INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
        LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
        OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
        PERFORMANCE OF THIS SOFTWARE.
        ***************************************************************************** */
        /* global Reflect, Promise */
        function __awaiter(thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }
            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }
            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        }
        function __generator(thisArg, body) {
          var _ = {
              label: 0,
              sent: function sent() {
                if (t[0] & 1) throw t[1];
                return t[1];
              },
              trys: [],
              ops: []
            },
            f,
            y,
            t,
            g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;
          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }
          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;
                case 4:
                  _.label++;
                  return {
                    value: op[1],
                    done: false
                  };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }
                  if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t[2]) _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        }
        var dist = {};
        var scriptPromiseCache = {};
        function loadScript$1(options) {
          var scriptLoadPromise;
          var stringifiedOptions = JSON.stringify(options);
          if (!options.forceScriptReload) {
            scriptLoadPromise = scriptPromiseCache[stringifiedOptions];
            if (scriptLoadPromise) {
              return scriptLoadPromise;
            }
          }
          var script = document.createElement("script");
          var attrs = options.dataAttributes || {};
          var container = options.container || document.head;
          script.src = options.src;
          script.id = options.id || "";
          script.async = true;
          if (options.type) {
            script.setAttribute("type", "".concat(options.type));
          }
          if (options.crossorigin) {
            script.setAttribute("crossorigin", "".concat(options.crossorigin));
          }
          Object.keys(attrs).forEach(function (key) {
            script.setAttribute("data-".concat(key), "".concat(attrs[key]));
          });
          scriptLoadPromise = new Promise(function (resolve, reject) {
            script.addEventListener("load", function () {
              resolve(script);
            });
            script.addEventListener("error", function () {
              reject(new Error("".concat(options.src, " failed to load.")));
            });
            script.addEventListener("abort", function () {
              reject(new Error("".concat(options.src, " has aborted.")));
            });
            container.appendChild(script);
          });
          scriptPromiseCache[stringifiedOptions] = scriptLoadPromise;
          return scriptLoadPromise;
        }
        loadScript$1.clearCache = function () {
          scriptPromiseCache = {};
        };
        var loadScript_1$1 = loadScript$1;
        var loadStylesheet$1 = function loadStylesheet(options) {
          var stylesheet = document.querySelector("link[href=\"".concat(options.href, "\"]"));
          if (stylesheet) {
            return Promise.resolve(stylesheet);
          }
          stylesheet = document.createElement("link");
          var container = options.container || document.head;
          stylesheet.setAttribute("rel", "stylesheet");
          stylesheet.setAttribute("type", "text/css");
          stylesheet.setAttribute("href", options.href);
          stylesheet.setAttribute("id", options.id);
          if (container.firstChild) {
            container.insertBefore(stylesheet, container.firstChild);
          } else {
            container.appendChild(stylesheet);
          }
          return Promise.resolve(stylesheet);
        };
        Object.defineProperty(dist, "__esModule", {
          value: true
        });
        dist.loadStylesheet = loadScript_1 = dist.loadScript = void 0;
        var loadScript = loadScript_1$1;
        var loadScript_1 = dist.loadScript = loadScript;
        var loadStylesheet = loadStylesheet$1;
        dist.loadStylesheet = loadStylesheet;
        var CDNX_PROD = "https://www.paypalobjects.com";
        var ASSET_NAME = {
          minified: "axo.min",
          unminified: "axo"
        };
        var FL_NAMESPACE = "fastlane";
        var ASSET_PATH = "connect-boba";
        var LOCALE_PATH = "".concat(ASSET_PATH, "/locales/");
        var constants = {
          AXO_ASSET_NAME: ASSET_NAME,
          AXO_ASSET_PATH: ASSET_PATH,
          LOCALE_PATH: LOCALE_PATH,
          CDNX_PROD: CDNX_PROD
        };
        var AxoSupportedPlatforms = {
          BT: "BT",
          PPCP: "PPCP"
        };

        /**
         * Checks if the current environment is an AMD environment.
         *
         * @returns {boolean} True if the environment is AMD, false otherwise.
         */
        function isAmdEnv() {
          return typeof window.define === "function" && !!window.define.amd;
        }
        /**
         * Checks if the current environment is a RequireJS environment.
         *
         * @returns {boolean} True if the environment is RequireJS, false otherwise.
         */
        function isRequireJsEnv() {
          return isAmdEnv() && typeof window.requirejs === "function" && typeof window.requirejs.config === "function";
        }

        /**
         * Safely loads BT modules by checking if the module already exists and verifying if versions mismatch
         *
         * @param loadConfig <BtModuleLoadConfig> Configuration of BT Module to load
         * @param version <string> version that should be passed from the client getVersion
         * @returns Promise<HTMLScriptElement>
         * @returns Promise<true> when BT module with same version already exists
         * @returns Promise.reject(err) when BT module already exists but versions mismatch or empty version passed in
         */
        function safeLoadBtModule(loadConfig, version, minified) {
          var _a, _b;
          if (minified === void 0) {
            minified = true;
          }
          return __awaiter(this, void 0, void 0, function () {
            var bt, existingVersion;
            return __generator(this, function (_c) {
              bt = getBraintree();
              if (bt && bt[loadConfig.module]) {
                if (version && ((_a = bt[loadConfig.module]) === null || _a === void 0 ? void 0 : _a.VERSION) !== version) {
                  existingVersion = (_b = bt[loadConfig.module]) === null || _b === void 0 ? void 0 : _b.VERSION;
                  throw new Error("".concat(loadConfig.module, " already loaded with version ").concat(existingVersion, " cannot load version ").concat(version));
                } else {
                  return [2 /*return*/, true];
                }
              }
              if (!version) {
                throw new Error("Attempted to load ".concat(loadConfig.module, " without specifying version"));
              }
              return [2 /*return*/, loadBtModule(loadConfig, version, minified)];
            });
          });
        }
        /**
         * Reads the version and to load the correct version of Bt module
         *
         * @param loadConfig <BtModuleLoadConfig> Configuration of BT Module to load
         * @param version <string> Bt module version
         * @returns Promise<HTMLScriptElement> or
         */
        function loadBtModule(loadConfig, version, minified) {
          if (minified === void 0) {
            minified = true;
          }
          if (isAmdEnv()) {
            var module_1 = minified ? loadConfig.amdModule.minified : loadConfig.amdModule.unminified;
            return new Promise(function (resolve, reject) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              window.require([module_1], resolve, reject);
            });
          }
          var script = minified ? loadConfig.script.minified : loadConfig.script.unminified;
          return loadScript_1({
            id: "".concat(loadConfig.id, "-").concat(version),
            src: "https://js.braintreegateway.com/web/".concat(version, "/js/").concat(script)
          });
        }
        /**
         * Looks for the Braintree web sdk on the window object
         *
         * @returns Braintree web sdk
         */
        function getBraintree() {
          return window === null || window === void 0 ? void 0 : window.braintree;
        }
        var _a, _b;
        /**
         * Maps to the BT module namespace created on the window.braintree object
         */
        var BtModule = {
          Client: "client",
          HostedCardFields: "hostedFields"
        };
        var BT_NAMESPACE = "braintree";
        var BT_ASSET_NAME = (_a = {}, _a[BtModule.Client] = "client", _a[BtModule.HostedCardFields] = "hosted-fields", _a);
        var btModulesLoadConfig = (_b = {}, _b[BtModule.Client] = {
          id: "client",
          module: BtModule.Client,
          amdModule: {
            unminified: "".concat(BT_NAMESPACE, "/").concat(BT_ASSET_NAME[BtModule.Client]),
            minified: "".concat(BT_NAMESPACE, "/").concat(BT_ASSET_NAME[BtModule.Client], ".min")
          },
          script: {
            unminified: "".concat(BT_ASSET_NAME[BtModule.Client], ".js"),
            minified: "".concat(BT_ASSET_NAME[BtModule.Client], ".min.js")
          }
        }, _b[BtModule.HostedCardFields] = {
          id: "hcf",
          module: BtModule.HostedCardFields,
          amdModule: {
            unminified: "".concat(BT_NAMESPACE, "/").concat(BT_ASSET_NAME[BtModule.HostedCardFields]),
            minified: "".concat(BT_NAMESPACE, "/").concat(BT_ASSET_NAME[BtModule.HostedCardFields], ".min")
          },
          script: {
            unminified: "".concat(BT_ASSET_NAME[BtModule.HostedCardFields], ".js"),
            minified: "".concat(BT_ASSET_NAME[BtModule.HostedCardFields], ".min.js")
          }
        }, _b);

        /**
         * Loads accelerated checkout components.
         * @param options object with a minified parameter to determine if the script that is loaded should be minified or not (defaults to true if)
         * @returns an object with metadata with a localeUrl parameter to be read by AXO SDK
         */
        function loadAxo(options) {
          return __awaiter(this, void 0, void 0, function () {
            var btSdkVersion, minified, assetUrl, localeUrl;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  performance.mark("pp_axo_sdk_init_invoked");
                  btSdkVersion = options.btSdkVersion, minified = options.minified;
                  assetUrl = getAssetsUrl(options);
                  localeUrl = getLocaleUrl(options);
                  if (!(options.platform === AxoSupportedPlatforms.BT)) return [3 /*break*/, 2];
                  return [4 /*yield*/, Promise.all([safeLoadBtModule(btModulesLoadConfig.hostedFields, btSdkVersion, minified), loadAXOScript(assetUrl, minified)])];
                case 1:
                  _a.sent();
                  return [3 /*break*/, 5];
                case 2:
                  if (!(options.platform === AxoSupportedPlatforms.PPCP)) return [3 /*break*/, 4];
                  return [4 /*yield*/, Promise.all([safeLoadBtModule(btModulesLoadConfig.client, btSdkVersion, minified), safeLoadBtModule(btModulesLoadConfig.hostedFields, btSdkVersion, minified), loadAXOScript(assetUrl, minified)])];
                case 3:
                  _a.sent();
                  return [3 /*break*/, 5];
                case 4:
                  throw new Error("unsupported axo platform");
                case 5:
                  return [2 /*return*/, {
                    metadata: {
                      localeUrl: localeUrl
                    }
                  }];
              }
            });
          });
        }
        /**
         * Reads the url and to load the axo bundle script
         * @param url (Required) string url for the correct axo asset
         * @returns Promise<HTMLScriptElement>
         */
        function loadAXOScript(url, minified) {
          var _a;
          if (minified === void 0) {
            minified = true;
          }
          if (isAmdEnv()) {
            // AMD environment
            if (isRequireJsEnv()) {
              // Let's configure RequireJS
              requirejs.config({
                paths: (_a = {}, _a[FL_NAMESPACE] = url, _a)
              });
            }
            var moduleName_1 = "".concat(FL_NAMESPACE, "/").concat(minified ? constants.AXO_ASSET_NAME.minified : constants.AXO_ASSET_NAME.unminified);
            return new Promise(function (resolve, reject) {
              window.require([moduleName_1], resolve, reject);
            });
          }
          // Not an AMD environment
          return loadScript_1({
            id: "axo-id",
            src: url,
            forceScriptReload: true
          });
        }
        /**
         * Prepends the domain to the asset url
         * @param options object with assetUrl and bundleid parameters to determine which URL to return
         * @returns full domain and assets URL as string
         */
        function generateAssetUrl(_a) {
          var assetUrl = _a.assetUrl,
            bundleId = _a.bundleId;
          return bundleId ? "https://cdn-".concat(bundleId, ".static.engineering.dev.paypalinc.com/").concat(assetUrl) : "".concat(constants.CDNX_PROD, "/").concat(assetUrl);
        }
        /**
         * Retrieves either the minified or unminified assets URL as specified
         * @param options (Optional) object with a minified and metadata with bundleIdOverride parameters to determine which URL to return
         * @returns assets URL as string
         */
        function getAssetsUrl(options) {
          var _a;
          var assetName = (options === null || options === void 0 ? void 0 : options.minified) !== false ? constants.AXO_ASSET_NAME.minified : constants.AXO_ASSET_NAME.unminified;
          var assetUrl = isAmdEnv() ? constants.AXO_ASSET_PATH : "".concat(constants.AXO_ASSET_PATH, "/").concat(assetName, ".js");
          return generateAssetUrl({
            assetUrl: assetUrl,
            bundleId: (_a = options === null || options === void 0 ? void 0 : options.metadata) === null || _a === void 0 ? void 0 : _a.bundleIdOverride
          });
        }
        /**
         * Retrieves the Locales URL, the path to our language files
         * @param options (Optional) object with a minified and metadata with bundleIdOverride parameters to determine which URL to return
         * @returns locale URL as string
         */
        function getLocaleUrl(options) {
          var _a;
          return generateAssetUrl({
            assetUrl: constants.LOCALE_PATH,
            bundleId: (_a = options === null || options === void 0 ? void 0 : options.metadata) === null || _a === void 0 ? void 0 : _a.bundleIdOverride
          });
        }
        exports.constants = constants;
        exports.loadAxo = loadAxo;
      });
    }, {}],
    9: [function (_dereq_, module, exports) {
      "use strict";

      var BRAINTREE_VERSION = _dereq_("./constants").BRAINTREE_VERSION;
      var GraphQL = _dereq_("./request/graphql");
      var request = _dereq_("./request");
      var isVerifiedDomain = _dereq_("../lib/is-verified-domain");
      var BraintreeError = _dereq_("../lib/braintree-error");
      var convertToBraintreeError = _dereq_("../lib/convert-to-braintree-error");
      var getGatewayConfiguration = _dereq_("./get-configuration").getConfiguration;
      var createAuthorizationData = _dereq_("../lib/create-authorization-data");
      var metadata = _dereq_("../lib/add-metadata");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var once = _dereq_("../lib/once");
      var deferred = _dereq_("../lib/deferred");
      var assign = _dereq_("../lib/assign").assign;
      var analytics = _dereq_("../lib/analytics");
      var errors = _dereq_("./errors");
      var VERSION = _dereq_("../lib/constants").VERSION;
      var GRAPHQL_URLS = _dereq_("../lib/constants").GRAPHQL_URLS;
      var methods = _dereq_("../lib/methods");
      var convertMethodsToError = _dereq_("../lib/convert-methods-to-error");
      var assets = _dereq_("../lib/assets");
      var FRAUDNET_FNCLS = _dereq_("../lib/constants").FRAUDNET_FNCLS;
      var FRAUDNET_SOURCE = _dereq_("../lib/constants").FRAUDNET_SOURCE;
      var FRAUDNET_URL = _dereq_("../lib/constants").FRAUDNET_URL;
      var cachedClients = {};

      /**
       * This object is returned by {@link Client#getConfiguration|getConfiguration}. This information is used extensively by other Braintree modules to properly configure themselves.
       * @typedef {object} Client~configuration
       * @property {object} client The braintree-web/client parameters.
       * @property {string} client.authorization A tokenizationKey or clientToken.
       * @property {object} gatewayConfiguration Gateway-supplied configuration.
       * @property {object} analyticsMetadata Analytics-specific data.
       * @property {string} analyticsMetadata.sessionId Uniquely identifies a browsing session.
       * @property {string} analyticsMetadata.sdkVersion The braintree.js version.
       * @property {string} analyticsMetadata.merchantAppId Identifies the merchant's web app.
       */

      /**
       * @class
       * @param {Client~configuration} configuration Options
       * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/client.create|braintree.client.create} instead.</strong>
       * @classdesc This class is required by many other Braintree components. It serves as the base API layer that communicates with our servers. It is also capable of being used to formulate direct calls to our servers, such as direct credit card tokenization. See {@link Client#request}.
       */
      function Client(configuration) {
        var configurationJSON, gatewayConfiguration;
        configuration = configuration || {};
        configurationJSON = JSON.stringify(configuration);
        gatewayConfiguration = configuration.gatewayConfiguration;
        if (!gatewayConfiguration) {
          throw new BraintreeError(errors.CLIENT_MISSING_GATEWAY_CONFIGURATION);
        }
        ["assetsUrl", "clientApiUrl", "configUrl"].forEach(function (property) {
          if (property in gatewayConfiguration && !isVerifiedDomain(gatewayConfiguration[property])) {
            throw new BraintreeError({
              type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
              code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
              message: property + " property is on an invalid domain."
            });
          }
        });

        /**
         * Returns a copy of the configuration values.
         * @public
         * @returns {Client~configuration} configuration
         */
        this.getConfiguration = function () {
          return JSON.parse(configurationJSON);
        };
        this._request = request;
        this._configuration = this.getConfiguration();
        this._clientApiBaseUrl = gatewayConfiguration.clientApiUrl + "/v1/";
        if (gatewayConfiguration.graphQL) {
          if (!isVerifiedDomain(gatewayConfiguration.graphQL.url)) {
            throw new BraintreeError({
              type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
              code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
              message: "graphQL.url property is on an invalid domain."
            });
          }
          this._graphQL = new GraphQL({
            graphQL: gatewayConfiguration.graphQL
          });
        }
      }
      Client.initialize = function (options) {
        var clientInstance, authData;
        var promise = cachedClients[options.authorization];
        if (promise) {
          analytics.sendEvent(promise, "custom.client.load.cached");
          return promise;
        }
        try {
          authData = createAuthorizationData(options.authorization);
        } catch (err) {
          return Promise.reject(new BraintreeError(errors.CLIENT_INVALID_AUTHORIZATION));
        }
        promise = getGatewayConfiguration(authData, options.sessionId).then(function (configuration) {
          if (options.debug) {
            configuration.isDebug = true;
          }
          configuration.authorization = options.authorization;
          clientInstance = new Client(configuration);
          return clientInstance;
        });
        cachedClients[options.authorization] = promise;
        analytics.sendEvent(promise, "custom.client.load.initialized");
        return promise.then(function (client) {
          analytics.sendEvent(clientInstance, "custom.client.load.succeeded");
          return client;
        }).catch(function (err) {
          delete cachedClients[options.authorization];
          return Promise.reject(err);
        });
      };

      // Primarily used for testing the client initalization call
      Client.clearCache = function () {
        cachedClients = {};
      };
      Client.prototype._findOrCreateFraudnetJSON = function (clientMetadataId) {
        var el = document.querySelector('script[fncls="' + FRAUDNET_FNCLS + '"]');
        var config, additionalData, authorizationFingerprint, parameters;
        if (!el) {
          el = document.body.appendChild(document.createElement("script"));
          el.type = "application/json";
          el.setAttribute("fncls", FRAUDNET_FNCLS);
        }
        config = this.getConfiguration();
        additionalData = {
          rda_tenant: "bt_card",
          // eslint-disable-line camelcase
          mid: config.gatewayConfiguration.merchantId
        };
        authorizationFingerprint = config.authorizationFingerprint;
        if (authorizationFingerprint) {
          authorizationFingerprint.split("&").forEach(function (pieces) {
            var component = pieces.split("=");
            if (component[0] === "customer_id" && component.length > 1) {
              additionalData.cid = component[1];
            }
          });
        }
        parameters = {
          f: clientMetadataId.substr(0, 32),
          fp: additionalData,
          bu: false,
          s: FRAUDNET_SOURCE
        };
        el.text = JSON.stringify(parameters);
      };

      /**
       * Used by other modules to formulate all network requests to the Braintree gateway. It is also capable of being used directly from your own form to tokenize credit card information. However, be sure to satisfy PCI compliance if you use direct card tokenization.
       * @public
       * @param {object} options Request options:
       * @param {string} options.method HTTP method, e.g. "get" or "post".
       * @param {string} options.endpoint Endpoint path, e.g. "payment_methods".
       * @param {object} options.data Data to send with the request.
       * @param {number} [options.timeout=60000] Set a timeout (in milliseconds) for the request.
       * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data.
       * @example
       * <caption>Direct Credit Card Tokenization</caption>
       * var createClient = require('braintree-web/client').create;
       *
       * createClient({
       *   authorization: CLIENT_AUTHORIZATION
       * }, function (createErr, clientInstance) {
       *   var form = document.getElementById('my-form-id');
       *   var data = {
       *     creditCard: {
       *       number: form['cc-number'].value,
       *       cvv: form['cc-cvv'].value,
       *       expirationDate: form['cc-expiration-date'].value,
       *       billingAddress: {
       *         postalCode: form['cc-postal-code'].value
       *       },
       *       options: {
       *         validate: false
       *       }
       *     }
       *   };
       *
       *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
       *   // payment fields cannot be hosted on your checkout page.
       *   // For an alternative to the following, use Hosted Fields.
       *   clientInstance.request({
       *     endpoint: 'payment_methods/credit_cards',
       *     method: 'post',
       *     data: data
       *   }, function (requestErr, response) {
       *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
       *     if (requestErr) { throw new Error(requestErr); }
       *
       *     console.log('Got nonce:', response.creditCards[0].nonce);
       *   });
       * });
       * @example
       * <caption>Tokenizing Fields for AVS Checks</caption>
       * var createClient = require('braintree-web/client').create;
       *
       * createClient({
       *   authorization: CLIENT_AUTHORIZATION
       * }, function (createErr, clientInstance) {
       *   var form = document.getElementById('my-form-id');
       *   var data = {
       *     creditCard: {
       *       number: form['cc-number'].value,
       *       cvv: form['cc-cvv'].value,
       *       expirationDate: form['cc-date'].value,
       *       // The billing address can be checked with AVS rules.
       *       // See: https://articles.braintreepayments.com/support/guides/fraud-tools/basic/avs-cvv-rules
       *       billingAddress: {
       *         postalCode: form['cc-postal-code'].value,
       *         streetAddress: form['cc-street-address'].value,
       *         countryName: form['cc-country-name'].value,
       *         countryCodeAlpha2: form['cc-country-alpha2'].value,
       *         countryCodeAlpha3: form['cc-country-alpha3'].value,
       *         countryCodeNumeric: form['cc-country-numeric'].value
       *       },
       *       options: {
       *         validate: false
       *       }
       *     }
       *   };
       *
       *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
       *   // payment fields cannot be hosted on your checkout page.
       *   // For an alternative to the following, use Hosted Fields.
       *   clientInstance.request({
       *     endpoint: 'payment_methods/credit_cards',
       *     method: 'post',
       *     data: data
       *   }, function (requestErr, response) {
       *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
       *     if (requestErr) { throw new Error(requestErr); }
       *
       *     console.log('Got nonce:', response.creditCards[0].nonce);
       *   });
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      Client.prototype.request = function (options, callback) {
        var self = this; // eslint-disable-line no-invalid-this
        var requestPromise = new Promise(function (resolve, reject) {
          var optionName, api, baseUrl, requestOptions;
          var shouldCollectData = Boolean(options.endpoint === "payment_methods/credit_cards" && self.getConfiguration().gatewayConfiguration.creditCards.collectDeviceData);
          if (options.api !== "graphQLApi") {
            if (!options.method) {
              optionName = "options.method";
            } else if (!options.endpoint) {
              optionName = "options.endpoint";
            }
          }
          if (optionName) {
            throw new BraintreeError({
              type: errors.CLIENT_OPTION_REQUIRED.type,
              code: errors.CLIENT_OPTION_REQUIRED.code,
              message: optionName + " is required when making a request."
            });
          }
          if ("api" in options) {
            api = options.api;
          } else {
            api = "clientApi";
          }
          requestOptions = {
            method: options.method,
            graphQL: self._graphQL,
            timeout: options.timeout,
            metadata: self._configuration.analyticsMetadata
          };
          if (api === "clientApi") {
            baseUrl = self._clientApiBaseUrl;
            requestOptions.data = metadata.addMetadata(self._configuration, options.data);
          } else if (api === "graphQLApi") {
            baseUrl = GRAPHQL_URLS[self._configuration.gatewayConfiguration.environment];
            options.endpoint = "";
            requestOptions.method = "post";
            requestOptions.data = assign({
              clientSdkMetadata: {
                platform: self._configuration.analyticsMetadata.platform,
                source: self._configuration.analyticsMetadata.source,
                integration: self._configuration.analyticsMetadata.integration,
                sessionId: self._configuration.analyticsMetadata.sessionId,
                version: VERSION
              }
            }, options.data);
            requestOptions.headers = getAuthorizationHeadersForGraphQL(self._configuration);
          } else {
            throw new BraintreeError({
              type: errors.CLIENT_OPTION_INVALID.type,
              code: errors.CLIENT_OPTION_INVALID.code,
              message: "options.api is invalid."
            });
          }
          requestOptions.url = baseUrl + options.endpoint;
          requestOptions.sendAnalyticsEvent = function (kind) {
            analytics.sendEvent(self, kind);
          };
          self._request(requestOptions, function (err, data, status) {
            var resolvedData, requestError;
            requestError = formatRequestError(status, err);
            if (requestError) {
              reject(requestError);
              return;
            }
            if (api === "graphQLApi" && data.errors) {
              reject(convertToBraintreeError(data.errors, {
                type: errors.CLIENT_GRAPHQL_REQUEST_ERROR.type,
                code: errors.CLIENT_GRAPHQL_REQUEST_ERROR.code,
                message: errors.CLIENT_GRAPHQL_REQUEST_ERROR.message
              }));
              return;
            }
            resolvedData = assign({
              _httpStatus: status
            }, data);
            if (shouldCollectData && resolvedData.creditCards && resolvedData.creditCards.length > 0) {
              self._findOrCreateFraudnetJSON(resolvedData.creditCards[0].nonce);
              assets.loadScript({
                src: FRAUDNET_URL,
                forceScriptReload: true
              });
            }
            resolve(resolvedData);
          });
        });
        if (typeof callback === "function") {
          callback = once(deferred(callback));
          requestPromise.then(function (response) {
            callback(null, response, response._httpStatus);
          }).catch(function (err) {
            var status = err && err.details && err.details.httpStatus;
            callback(err, null, status);
          });
          return;
        }
        return requestPromise; // eslint-disable-line consistent-return
      };

      // eslint-disable-next-line consistent-return
      function formatRequestError(status, err) {
        var requestError;
        if (status === -1) {
          requestError = new BraintreeError(errors.CLIENT_REQUEST_TIMEOUT);
        } else if (status === 401) {
          requestError = new BraintreeError(errors.CLIENT_AUTHORIZATION_INVALID);
        } else if (status === 403) {
          requestError = new BraintreeError(errors.CLIENT_AUTHORIZATION_INSUFFICIENT);
        } else if (status === 429) {
          requestError = new BraintreeError(errors.CLIENT_RATE_LIMITED);
        } else if (status >= 500) {
          requestError = new BraintreeError(errors.CLIENT_GATEWAY_NETWORK);
        } else if (status < 200 || status >= 400) {
          requestError = convertToBraintreeError(err, {
            type: errors.CLIENT_REQUEST_ERROR.type,
            code: errors.CLIENT_REQUEST_ERROR.code,
            message: errors.CLIENT_REQUEST_ERROR.message
          });
        }
        if (requestError) {
          requestError.details = requestError.details || {};
          requestError.details.httpStatus = status;
          return requestError;
        }
      }
      Client.prototype.toJSON = function () {
        return this.getConfiguration();
      };

      /**
       * Returns the Client version.
       * @public
       * @returns {String} The created client's version.
       * @example
       * var createClient = require('braintree-web/client').create;
       *
       * createClient({
       *   authorization: CLIENT_AUTHORIZATION
       * }, function (createErr, clientInstance) {
       *   console.log(clientInstance.getVersion()); // Ex: 1.0.0
       * });
       * @returns {void}
       */
      Client.prototype.getVersion = function () {
        return VERSION;
      };

      /**
       * Cleanly tear down anything set up by {@link module:braintree-web/client.create|create}.
       * @public
       * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
       * @example
       * clientInstance.teardown();
       * @example <caption>With callback</caption>
       * clientInstance.teardown(function () {
       *   // teardown is complete
       * });
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       */
      Client.prototype.teardown = wrapPromise(function () {
        var self = this; // eslint-disable-line no-invalid-this

        delete cachedClients[self.getConfiguration().authorization];
        convertMethodsToError(self, methods(Client.prototype));
        return Promise.resolve();
      });
      function getAuthorizationHeadersForGraphQL(configuration) {
        var token = configuration.authorizationFingerprint || configuration.authorization;
        return {
          Authorization: "Bearer " + token,
          "Braintree-Version": BRAINTREE_VERSION
        };
      }
      module.exports = Client;
    }, {
      "../lib/add-metadata": 29,
      "../lib/analytics": 30,
      "../lib/assets": 31,
      "../lib/assign": 32,
      "../lib/braintree-error": 33,
      "../lib/constants": 34,
      "../lib/convert-methods-to-error": 35,
      "../lib/convert-to-braintree-error": 36,
      "../lib/create-authorization-data": 37,
      "../lib/deferred": 38,
      "../lib/is-verified-domain": 43,
      "../lib/methods": 45,
      "../lib/once": 46,
      "./constants": 10,
      "./errors": 11,
      "./get-configuration": 12,
      "./request": 25,
      "./request/graphql": 23,
      "@braintree/wrap-promise": 7
    }],
    10: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = {
        BRAINTREE_VERSION: "2018-05-10"
      };
    }, {}],
    11: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Client - Internal Error Codes
       * @ignore
       * @description These codes should never be experienced by the merchant directly.
       * @property {MERCHANT} CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN An error to prevent client creation for domains that are not allowed in the JS.
       * @property {INTERNAL} CLIENT_MISSING_GATEWAY_CONFIGURATION Occurs when the client is created without a gateway configuration. Should never happen.
       */

      /**
       * @name BraintreeError.Client - Create Error Codes
       * @description Errors that may occur when [creating the client](./module-braintree-web_client.html#.create)
       * @property {MERCHANT} CLIENT_INVALID_AUTHORIZATION Occurs when client token cannot be parsed.
       */

      /**
       * @name BraintreeError.Client - Request Error Codes
       * @description Errors that may occur when [using the request method](./Client.html#request)
       * @property {MERCHANT} CLIENT_OPTION_REQUIRED An option required in the request method was not provided. Usually `options.method` or `options.endpoint`
       * @property {MERCHANT} CLIENT_OPTION_INVALID The request option provided is invalid.
       * @property {MERCHANT} CLIENT_GATEWAY_NETWORK The Braintree gateway could not be contacted.
       * @property {NETWORK} CLIENT_REQUEST_TIMEOUT The request took too long to complete and timed out.
       * @property {NETWORK} CLIENT_REQUEST_ERROR The response from a request had status 400 or greater.
       * @property {NETWORK} CLIENT_GRAPHQL_REQUEST_ERROR The response from a request to GraphQL contained an error.
       * @property {MERCHANT} CLIENT_RATE_LIMITED The response from a request had a status of 429, indicating rate limiting.
       * @property {MERCHANT} CLIENT_AUTHORIZATION_INSUFFICIENT The user associated with the client token or tokenization key does not have permissions to make the request.
       * @property {MERCHANT} CLIENT_AUTHORIZATION_INVALID The provided authorization could not be found. Either the client token has expired and a new client token must be generated or the tokenization key used is set to be inactive or has been deleted.
       */
      var BraintreeError = _dereq_("../lib/braintree-error");
      module.exports = {
        CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN"
        },
        CLIENT_OPTION_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_OPTION_REQUIRED"
        },
        CLIENT_OPTION_INVALID: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_OPTION_INVALID"
        },
        CLIENT_MISSING_GATEWAY_CONFIGURATION: {
          type: BraintreeError.types.INTERNAL,
          code: "CLIENT_MISSING_GATEWAY_CONFIGURATION",
          message: "Missing gatewayConfiguration."
        },
        CLIENT_INVALID_AUTHORIZATION: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_INVALID_AUTHORIZATION",
          message: "Authorization is invalid. Make sure your client token or tokenization key is valid."
        },
        CLIENT_GATEWAY_NETWORK: {
          type: BraintreeError.types.NETWORK,
          code: "CLIENT_GATEWAY_NETWORK",
          message: "Cannot contact the gateway at this time."
        },
        CLIENT_REQUEST_TIMEOUT: {
          type: BraintreeError.types.NETWORK,
          code: "CLIENT_REQUEST_TIMEOUT",
          message: "Request timed out waiting for a reply."
        },
        CLIENT_REQUEST_ERROR: {
          type: BraintreeError.types.NETWORK,
          code: "CLIENT_REQUEST_ERROR",
          message: "There was a problem with your request."
        },
        CLIENT_GRAPHQL_REQUEST_ERROR: {
          type: BraintreeError.types.NETWORK,
          code: "CLIENT_GRAPHQL_REQUEST_ERROR",
          message: "There was a problem with your request."
        },
        CLIENT_RATE_LIMITED: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_RATE_LIMITED",
          message: "You are being rate-limited; please try again in a few minutes."
        },
        CLIENT_AUTHORIZATION_INSUFFICIENT: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_AUTHORIZATION_INSUFFICIENT",
          message: "The authorization used has insufficient privileges."
        },
        CLIENT_AUTHORIZATION_INVALID: {
          type: BraintreeError.types.MERCHANT,
          code: "CLIENT_AUTHORIZATION_INVALID",
          message: "Either the client token has expired and a new one should be generated or the tokenization key has been deactivated or deleted."
        }
      };
    }, {
      "../lib/braintree-error": 33
    }],
    12: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../lib/braintree-error");
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var request = _dereq_("./request");
      var uuid = _dereq_("@braintree/uuid");
      var constants = _dereq_("../lib/constants");
      var errors = _dereq_("./errors");
      var GraphQL = _dereq_("./request/graphql");
      var GRAPHQL_URLS = _dereq_("../lib/constants").GRAPHQL_URLS;
      var isDateStringBeforeOrOn = _dereq_("../lib/is-date-string-before-or-on");
      var BRAINTREE_VERSION = _dereq_("./constants").BRAINTREE_VERSION;
      function getConfiguration(authData, inputSessionId) {
        return new Promise(function (resolve, reject) {
          var configuration, attrs, configUrl, reqOptions;
          var sessionId = inputSessionId || uuid();
          var analyticsMetadata = {
            merchantAppId: window.location.host,
            platform: constants.PLATFORM,
            sdkVersion: constants.VERSION,
            source: constants.SOURCE,
            // NEXT_MAJOR_VERSION remove one of these to not duplicate data. Target parity with mobile platforms approach.
            integration: constants.INTEGRATION,
            integrationType: constants.INTEGRATION,
            sessionId: sessionId
          };
          attrs = authData.attrs;
          configUrl = authData.configUrl;
          attrs._meta = analyticsMetadata;
          attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;
          attrs.configVersion = "3";
          reqOptions = {
            url: configUrl,
            method: "GET",
            data: attrs
          };
          if (attrs.authorizationFingerprint && authData.graphQL) {
            if (isDateStringBeforeOrOn(authData.graphQL.date, BRAINTREE_VERSION)) {
              reqOptions.graphQL = new GraphQL({
                graphQL: {
                  url: authData.graphQL.url,
                  features: ["configuration"]
                }
              });
            }
            reqOptions.metadata = analyticsMetadata;
          } else if (attrs.tokenizationKey) {
            reqOptions.graphQL = new GraphQL({
              graphQL: {
                url: GRAPHQL_URLS[authData.environment],
                features: ["configuration"]
              }
            });
            reqOptions.metadata = analyticsMetadata;
          }
          request(reqOptions, function (err, response, status) {
            var errorTemplate;
            if (err) {
              if (status === 403) {
                errorTemplate = errors.CLIENT_AUTHORIZATION_INSUFFICIENT;
              } else if (status === 401) {
                errorTemplate = errors.CLIENT_AUTHORIZATION_INVALID;
              } else {
                errorTemplate = errors.CLIENT_GATEWAY_NETWORK;
              }
              reject(new BraintreeError({
                type: errorTemplate.type,
                code: errorTemplate.code,
                message: errorTemplate.message,
                details: {
                  originalError: err
                }
              }));
              return;
            }
            configuration = {
              authorizationType: attrs.tokenizationKey ? "TOKENIZATION_KEY" : "CLIENT_TOKEN",
              authorizationFingerprint: attrs.authorizationFingerprint,
              analyticsMetadata: analyticsMetadata,
              gatewayConfiguration: response
            };
            resolve(configuration);
          });
        });
      }
      module.exports = {
        getConfiguration: wrapPromise(getConfiguration)
      };
    }, {
      "../lib/braintree-error": 33,
      "../lib/constants": 34,
      "../lib/is-date-string-before-or-on": 41,
      "./constants": 10,
      "./errors": 11,
      "./request": 25,
      "./request/graphql": 23,
      "@braintree/uuid": 3,
      "@braintree/wrap-promise": 7
    }],
    13: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("../lib/braintree-error");
      var Client = _dereq_("./client");
      var VERSION = "3.118.2";
      var wrapPromise = _dereq_("@braintree/wrap-promise");
      var sharedErrors = _dereq_("../lib/errors");

      /** @module braintree-web/client */

      /**
       * @function create
       * @description This function is the entry point for the <code>braintree.client</code> module. It is used for creating {@link Client} instances that service communication to Braintree servers.
       * @param {object} options Object containing all {@link Client} options:
       * @param {string} options.authorization A tokenizationKey or clientToken.
       * @param {callback} [callback] The second argument, <code>data</code>, is the {@link Client} instance.
       * @returns {(Promise|void)} Returns a promise if no callback is provided.
       * @example
       * var createClient = require('braintree-web/client').create;
       *
       * createClient({
       *   authorization: CLIENT_AUTHORIZATION
       * }, function (createErr, clientInstance) {
       *   if (createErr) {
       *     if (createErr.code === 'CLIENT_AUTHORIZATION_INVALID') {
       *       // either the client token has expired, and a new one should be generated
       *       // or the tokenization key was deactivated or deleted
       *     } else {
       *       console.log('something went wrong creating the client instance', createErr);
       *     }
       *     return;
       *   }
       *
       *  // set up other components
       * });
       * @static
       */
      function create(options) {
        if (!options.authorization) {
          return Promise.reject(new BraintreeError({
            type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
            code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
            message: "options.authorization is required when instantiating a client."
          }));
        }
        return Client.initialize(options);
      }
      module.exports = {
        create: wrapPromise(create),
        /**
         * @description The current version of the SDK, i.e. `{@pkg version}`.
         * @type {string}
         */
        VERSION: VERSION
      };
    }, {
      "../lib/braintree-error": 33,
      "../lib/errors": 40,
      "./client": 9,
      "@braintree/wrap-promise": 7
    }],
    14: [function (_dereq_, module, exports) {
      "use strict";

      var querystring = _dereq_("../../lib/querystring");
      var assign = _dereq_("../../lib/assign").assign;
      var prepBody = _dereq_("./prep-body");
      var parseBody = _dereq_("./parse-body");
      var xhr = _dereq_("./xhr");
      var isXHRAvailable = xhr.isAvailable;
      var GraphQLRequest = _dereq_("./graphql/request");
      var DefaultRequest = _dereq_("./default-request");
      var MAX_TCP_RETRYCOUNT = 1;
      var TCP_PRECONNECT_BUG_STATUS_CODE = 408;
      function requestShouldRetry(status) {
        return !status || status === TCP_PRECONNECT_BUG_STATUS_CODE;
      }
      function graphQLRequestShouldRetryWithClientApi(body) {
        var errorClass = !body.data && body.errors && body.errors[0] && body.errors[0].extensions && body.errors[0].extensions.errorClass;
        return errorClass === "UNKNOWN" || errorClass === "INTERNAL";
      }
      function _requestWithRetry(options, tcpRetryCount, cb) {
        var status, resBody, ajaxRequest, body, method, headers, parsedBody;
        var url = options.url;
        var graphQL = options.graphQL;
        var timeout = options.timeout;
        var req = xhr.getRequestObject();
        var callback = cb;
        var isGraphQLRequest = Boolean(graphQL && graphQL.isGraphQLRequest(url, options.data));
        options.headers = assign({
          "Content-Type": "application/json"
        }, options.headers);
        if (isGraphQLRequest) {
          ajaxRequest = new GraphQLRequest(options);
        } else {
          ajaxRequest = new DefaultRequest(options);
        }
        url = ajaxRequest.getUrl();
        body = ajaxRequest.getBody();
        method = ajaxRequest.getMethod();
        headers = ajaxRequest.getHeaders();
        if (method === "GET") {
          url = querystring.queryify(url, body);
          body = null;
        }
        if (isXHRAvailable) {
          req.onreadystatechange = function () {
            if (req.readyState !== 4) {
              return;
            }
            if (req.status === 0 && isGraphQLRequest) {
              // If a merchant experiences a connection
              // issue to the GraphQL endpoint (possibly
              // due to a Content Security Policy), retry
              // the request against the old client API.
              delete options.graphQL;
              _requestWithRetry(options, tcpRetryCount, cb);
              return;
            }
            parsedBody = parseBody(req.responseText);
            resBody = ajaxRequest.adaptResponseBody(parsedBody);
            status = ajaxRequest.determineStatus(req.status, parsedBody);
            if (status >= 400 || status < 200) {
              if (isGraphQLRequest && graphQLRequestShouldRetryWithClientApi(parsedBody)) {
                delete options.graphQL;
                _requestWithRetry(options, tcpRetryCount, cb);
                return;
              }
              if (tcpRetryCount < MAX_TCP_RETRYCOUNT && requestShouldRetry(status)) {
                tcpRetryCount++;
                _requestWithRetry(options, tcpRetryCount, cb);
                return;
              }
              callback(resBody || "error", null, status || 500);
            } else {
              callback(null, resBody, status);
            }
          };
        } else {
          if (options.headers) {
            url = querystring.queryify(url, headers);
          }
          req.onload = function () {
            callback(null, parseBody(req.responseText), req.status);
          };
          req.onerror = function () {
            // XDomainRequest does not report a body or status for errors, so
            // hardcode to 'error' and 500, respectively
            callback("error", null, 500);
          };

          // This must remain for IE9 to work
          req.onprogress = function () {};
          req.ontimeout = function () {
            callback("timeout", null, -1);
          };
        }
        try {
          req.open(method, url, true);
        } catch (requestOpenError) {
          // If a merchant has a Content Security Policy and they have
          // not allowed our endpoints, some browsers may
          // synchronously throw an error. If it is not a GraphQL
          // request, we throw the error. If it is a GraphQL request
          // we remove the GraphQL option and try the request against
          // the old client API.
          if (!isGraphQLRequest) {
            throw requestOpenError;
          }
          delete options.graphQL;
          _requestWithRetry(options, tcpRetryCount, cb);
          return;
        }
        req.timeout = timeout;
        if (isXHRAvailable) {
          Object.keys(headers).forEach(function (headerKey) {
            req.setRequestHeader(headerKey, headers[headerKey]);
          });
        }
        try {
          req.send(prepBody(method, body));
        } catch (e) {
          /* ignored */
        }
      }
      function request(options, cb) {
        _requestWithRetry(options, 0, cb);
      }
      module.exports = {
        request: request
      };
    }, {
      "../../lib/assign": 32,
      "../../lib/querystring": 47,
      "./default-request": 15,
      "./graphql/request": 24,
      "./parse-body": 26,
      "./prep-body": 27,
      "./xhr": 28
    }],
    15: [function (_dereq_, module, exports) {
      "use strict";

      function DefaultRequest(options) {
        this._url = options.url;
        this._data = options.data;
        this._method = options.method;
        this._headers = options.headers;
      }
      DefaultRequest.prototype.getUrl = function () {
        return this._url;
      };
      DefaultRequest.prototype.getBody = function () {
        return this._data;
      };
      DefaultRequest.prototype.getMethod = function () {
        return this._method;
      };
      DefaultRequest.prototype.getHeaders = function () {
        return this._headers;
      };
      DefaultRequest.prototype.adaptResponseBody = function (parsedBody) {
        return parsedBody;
      };
      DefaultRequest.prototype.determineStatus = function (status) {
        return status;
      };
      module.exports = DefaultRequest;
    }, {}],
    16: [function (_dereq_, module, exports) {
      "use strict";

      var errorResponseAdapter = _dereq_("./error");
      var assign = _dereq_("../../../../lib/assign").assign;

      /* eslint-disable camelcase */
      var cardTypeTransforms = {
        creditCard: {
          AMERICAN_EXPRESS: "American Express",
          DISCOVER: "Discover",
          INTERNATIONAL_MAESTRO: "Maestro",
          JCB: "JCB",
          MASTERCARD: "MasterCard",
          SOLO: "Solo",
          UK_MAESTRO: "UK Maestro",
          UNION_PAY: "UnionPay",
          VISA: "Visa",
          ELO: "Elo",
          HIPER: "Hiper",
          HIPERCARD: "Hipercard"
        },
        applePayWeb: {
          VISA: "visa",
          MASTERCARD: "mastercard",
          DISCOVER: "discover",
          AMERICAN_EXPRESS: "amex",
          INTERNATIONAL_MAESTRO: "maestro",
          ELO: "elo"
        },
        visaCheckout: {
          VISA: "Visa",
          MASTERCARD: "MasterCard",
          DISCOVER: "Discover",
          AMERICAN_EXPRESS: "American Express"
        },
        googlePay: {
          VISA: "visa",
          MASTERCARD: "mastercard",
          DISCOVER: "discover",
          AMERICAN_EXPRESS: "amex",
          INTERNATIONAL_MAESTRO: "maestro",
          ELO: "elo"
        },
        masterpass: {
          VISA: "visa",
          MASTERCARD: "master",
          DISCOVER: "discover",
          AMERICAN_EXPRESS: "amex",
          DINERS: "diners",
          INTERNATIONAL_MAESTRO: "maestro",
          JCB: "jcb"
        }
      };
      /* eslint-enable camelcase */

      function configurationResponseAdapter(responseBody, ctx) {
        var adaptedResponse;
        if (responseBody.data && !responseBody.errors) {
          adaptedResponse = adaptConfigurationResponseBody(responseBody, ctx);
        } else {
          adaptedResponse = errorResponseAdapter(responseBody);
        }
        return adaptedResponse;
      }
      function adaptConfigurationResponseBody(body, ctx) {
        var configuration = body.data.clientConfiguration;
        var response;
        response = {
          environment: configuration.environment.toLowerCase(),
          clientApiUrl: configuration.clientApiUrl,
          assetsUrl: configuration.assetsUrl,
          analytics: {
            url: configuration.analyticsUrl
          },
          merchantId: configuration.merchantId,
          venmo: "off"
        };
        if (configuration.supportedFeatures) {
          response.graphQL = {
            url: ctx._graphQL._config.url,
            features: configuration.supportedFeatures.map(function (feature) {
              return feature.toLowerCase();
            })
          };
        }
        if (configuration.braintreeApi) {
          response.braintreeApi = configuration.braintreeApi;
        }
        if (configuration.applePayWeb) {
          response.applePayWeb = configuration.applePayWeb;
          response.applePayWeb.supportedNetworks = mapCardTypes(configuration.applePayWeb.supportedCardBrands, cardTypeTransforms.applePayWeb);
          delete response.applePayWeb.supportedCardBrands;
        }
        if (configuration.fastlane) {
          response.fastlane = configuration.fastlane;
        }
        if (configuration.ideal) {
          response.ideal = configuration.ideal;
        }
        if (configuration.creditCard) {
          response.challenges = configuration.creditCard.challenges.map(function (challenge) {
            return challenge.toLowerCase();
          });
          response.creditCards = {
            supportedCardTypes: mapCardTypes(configuration.creditCard.supportedCardBrands, cardTypeTransforms.creditCard)
          };
          response.threeDSecureEnabled = configuration.creditCard.threeDSecureEnabled;
          response.threeDSecure = configuration.creditCard.threeDSecure;
        } else {
          response.challenges = [];
          response.creditCards = {
            supportedCardTypes: []
          };
          response.threeDSecureEnabled = false;
        }
        if (configuration.googlePay) {
          response.androidPay = {
            displayName: configuration.googlePay.displayName,
            enabled: true,
            environment: configuration.googlePay.environment.toLowerCase(),
            googleAuthorizationFingerprint: configuration.googlePay.googleAuthorization,
            paypalClientId: configuration.googlePay.paypalClientId,
            supportedNetworks: mapCardTypes(configuration.googlePay.supportedCardBrands, cardTypeTransforms.googlePay)
          };
        }
        if (configuration.venmo) {
          response.payWithVenmo = {
            merchantId: configuration.venmo.merchantId,
            accessToken: configuration.venmo.accessToken,
            environment: configuration.venmo.environment.toLowerCase(),
            enrichedCustomerDataEnabled: configuration.venmo.enrichedCustomerDataEnabled
          };
        }
        if (configuration.paypal) {
          response.paypalEnabled = true;
          response.paypal = assign({}, configuration.paypal);
          response.paypal.currencyIsoCode = response.paypal.currencyCode;
          response.paypal.environment = response.paypal.environment.toLowerCase();
          delete response.paypal.currencyCode;
        } else {
          response.paypalEnabled = false;
        }
        if (configuration.unionPay) {
          response.unionPay = {
            enabled: true,
            merchantAccountId: configuration.unionPay.merchantAccountId
          };
        }
        if (configuration.visaCheckout) {
          response.visaCheckout = {
            apikey: configuration.visaCheckout.apiKey,
            encryptionKey: configuration.visaCheckout.encryptionKey,
            externalClientId: configuration.visaCheckout.externalClientId,
            supportedCardTypes: mapCardTypes(configuration.visaCheckout.supportedCardBrands, cardTypeTransforms.visaCheckout)
          };
        }
        if (configuration.masterpass) {
          response.masterpass = {
            merchantCheckoutId: configuration.masterpass.merchantCheckoutId,
            supportedNetworks: mapCardTypes(configuration.masterpass.supportedCardBrands, cardTypeTransforms.masterpass)
          };
        }
        if (configuration.usBankAccount) {
          response.usBankAccount = {
            routeId: configuration.usBankAccount.routeId,
            plaid: {
              publicKey: configuration.usBankAccount.plaidPublicKey
            }
          };
        }
        return response;
      }
      function mapCardTypes(cardTypes, cardTypeTransformMap) {
        return cardTypes.reduce(function (acc, type) {
          if (cardTypeTransformMap.hasOwnProperty(type)) {
            return acc.concat(cardTypeTransformMap[type]);
          }
          return acc;
        }, []);
      }
      module.exports = configurationResponseAdapter;
    }, {
      "../../../../lib/assign": 32,
      "./error": 19
    }],
    17: [function (_dereq_, module, exports) {
      "use strict";

      var errorResponseAdapter = _dereq_("./error");
      var CARD_BRAND_MAP = {
        /* eslint-disable camelcase */
        AMERICAN_EXPRESS: "American Express",
        DINERS: "Discover",
        DISCOVER: "Discover",
        ELO: "Elo",
        HIPER: "Hiper",
        HIPERCARD: "Hipercard",
        INTERNATIONAL_MAESTRO: "Maestro",
        JCB: "JCB",
        MASTERCARD: "MasterCard",
        UK_MAESTRO: "Maestro",
        UNION_PAY: "UnionPay",
        VISA: "Visa"
        /* eslint-enable camelcase */
      };
      var BIN_DATA_MAP = {
        YES: "Yes",
        NO: "No",
        UNKNOWN: "Unknown"
      };
      var AUTHENTICATION_INSIGHT_MAP = {
        PSDTWO: "psd2"
      };
      function creditCardTokenizationFastlaneResponseAdapter(responseBody) {
        var adaptedResponse;
        if (responseBody.data && !responseBody.errors) {
          adaptedResponse = adaptTokenizeCreditCardForFastlaneResponseBody(responseBody);
        } else {
          adaptedResponse = errorResponseAdapter(responseBody);
        }
        return adaptedResponse;
      }
      function adaptTokenizeCreditCardForFastlaneResponseBody(body) {
        var data = body.data.tokenizeCreditCardForPayPalConnect;
        var creditCard = data.paymentMethod.details;
        var lastTwo = creditCard.last4 ? creditCard.last4.substr(2, 4) : "";
        var binData = creditCard.binData;
        var response, regulationEnvironment;
        if (binData) {
          ["commercial", "debit", "durbinRegulated", "healthcare", "payroll", "prepaid"].forEach(function (key) {
            if (binData[key]) {
              binData[key] = BIN_DATA_MAP[binData[key]];
            } else {
              binData[key] = "Unknown";
            }
          });
          ["issuingBank", "countryOfIssuance", "productId"].forEach(function (key) {
            if (!binData[key]) {
              binData[key] = "Unknown";
            }
          });
        }
        response = {
          creditCards: [{
            binData: binData,
            consumed: false,
            description: lastTwo ? "ending in " + lastTwo : "",
            nonce: data.paymentMethod.id,
            details: {
              cardholderName: creditCard.cardholderName,
              expirationMonth: creditCard.expirationMonth,
              expirationYear: creditCard.expirationYear,
              bin: creditCard.bin || "",
              cardType: CARD_BRAND_MAP[creditCard.brandCode] || "Unknown",
              lastFour: creditCard.last4 || "",
              lastTwo: lastTwo
            },
            type: "CreditCard",
            threeDSecureInfo: null
          }]
        };
        if (data.authenticationInsight) {
          regulationEnvironment = data.authenticationInsight.customerAuthenticationRegulationEnvironment;
          response.creditCards[0].authenticationInsight = {
            regulationEnvironment: AUTHENTICATION_INSIGHT_MAP[regulationEnvironment] || regulationEnvironment.toLowerCase()
          };
        }
        return response;
      }
      module.exports = creditCardTokenizationFastlaneResponseAdapter;
    }, {
      "./error": 19
    }],
    18: [function (_dereq_, module, exports) {
      "use strict";

      var errorResponseAdapter = _dereq_("./error");
      var CARD_BRAND_MAP = {
        /* eslint-disable camelcase */
        AMERICAN_EXPRESS: "American Express",
        DINERS: "Discover",
        DISCOVER: "Discover",
        ELO: "Elo",
        HIPER: "Hiper",
        HIPERCARD: "Hipercard",
        INTERNATIONAL_MAESTRO: "Maestro",
        JCB: "JCB",
        MASTERCARD: "MasterCard",
        UK_MAESTRO: "Maestro",
        UNION_PAY: "UnionPay",
        VISA: "Visa"
        /* eslint-enable camelcase */
      };
      var BIN_DATA_MAP = {
        YES: "Yes",
        NO: "No",
        UNKNOWN: "Unknown"
      };
      var AUTHENTICATION_INSIGHT_MAP = {
        PSDTWO: "psd2"
      };
      function creditCardTokenizationResponseAdapter(responseBody) {
        var adaptedResponse;
        if (responseBody.data && !responseBody.errors) {
          adaptedResponse = adaptTokenizeCreditCardResponseBody(responseBody);
        } else {
          adaptedResponse = errorResponseAdapter(responseBody);
        }
        return adaptedResponse;
      }
      function adaptTokenizeCreditCardResponseBody(body) {
        var data = body.data.tokenizeCreditCard;
        var creditCard = data.creditCard;
        var lastTwo = creditCard.last4 ? creditCard.last4.substr(2, 4) : "";
        var binData = creditCard.binData;
        var response, regulationEnvironment;
        if (binData) {
          ["commercial", "debit", "durbinRegulated", "healthcare", "payroll", "prepaid"].forEach(function (key) {
            if (binData[key]) {
              binData[key] = BIN_DATA_MAP[binData[key]];
            } else {
              binData[key] = "Unknown";
            }
          });
          ["issuingBank", "countryOfIssuance", "productId"].forEach(function (key) {
            if (!binData[key]) {
              binData[key] = "Unknown";
            }
          });
        }
        response = {
          creditCards: [{
            binData: binData,
            consumed: false,
            description: lastTwo ? "ending in " + lastTwo : "",
            nonce: data.token,
            details: {
              cardholderName: creditCard.cardholderName,
              expirationMonth: creditCard.expirationMonth,
              expirationYear: creditCard.expirationYear,
              bin: creditCard.bin || "",
              cardType: CARD_BRAND_MAP[creditCard.brandCode] || "Unknown",
              lastFour: creditCard.last4 || "",
              lastTwo: lastTwo
            },
            type: "CreditCard",
            threeDSecureInfo: null
          }]
        };
        if (data.authenticationInsight) {
          regulationEnvironment = data.authenticationInsight.customerAuthenticationRegulationEnvironment;
          response.creditCards[0].authenticationInsight = {
            regulationEnvironment: AUTHENTICATION_INSIGHT_MAP[regulationEnvironment] || regulationEnvironment.toLowerCase()
          };
        }
        return response;
      }
      module.exports = creditCardTokenizationResponseAdapter;
    }, {
      "./error": 19
    }],
    19: [function (_dereq_, module, exports) {
      "use strict";

      function errorResponseAdapter(responseBody) {
        var response;
        var errorClass = responseBody.errors && responseBody.errors[0] && responseBody.errors[0].extensions && responseBody.errors[0].extensions.errorClass;
        if (errorClass === "VALIDATION") {
          response = userErrorResponseAdapter(responseBody);
        } else if (errorClass) {
          response = errorWithClassResponseAdapter(responseBody);
        } else {
          response = {
            error: {
              message: "There was a problem serving your request"
            },
            fieldErrors: []
          };
        }
        return response;
      }
      function errorWithClassResponseAdapter(responseBody) {
        return {
          error: {
            message: responseBody.errors[0].message
          },
          fieldErrors: []
        };
      }
      function userErrorResponseAdapter(responseBody) {
        var fieldErrors = buildFieldErrors(responseBody.errors);
        if (fieldErrors.length === 0) {
          return {
            error: {
              message: responseBody.errors[0].message
            }
          };
        }
        return {
          error: {
            message: getLegacyMessage(fieldErrors)
          },
          fieldErrors: fieldErrors
        };
      }
      function buildFieldErrors(errors) {
        var fieldErrors = [];
        errors.forEach(function (error) {
          if (!(error.extensions && error.extensions.inputPath)) {
            return;
          }
          addFieldError(error.extensions.inputPath.slice(1), error, fieldErrors);
        });
        return fieldErrors;
      }
      function addFieldError(inputPath, errorDetail, fieldErrors) {
        var fieldError;
        var legacyCode = errorDetail.extensions.legacyCode;
        var inputField = inputPath[0];
        if (inputPath.length === 1) {
          fieldErrors.push({
            code: legacyCode,
            field: inputField,
            message: errorDetail.message
          });
          return;
        }
        fieldErrors.forEach(function (candidate) {
          if (candidate.field === inputField) {
            fieldError = candidate;
          }
        });
        if (!fieldError) {
          fieldError = {
            field: inputField,
            fieldErrors: []
          };
          fieldErrors.push(fieldError);
        }
        addFieldError(inputPath.slice(1), errorDetail, fieldError.fieldErrors);
      }
      function getLegacyMessage(errors) {
        var legacyMessages = {
          creditCard: "Credit card is invalid"
        };
        var field = errors[0].field;
        return legacyMessages[field];
      }
      module.exports = errorResponseAdapter;
    }, {}],
    20: [function (_dereq_, module, exports) {
      "use strict";

      var CONFIGURATION_QUERY = "query ClientConfiguration { " + "  clientConfiguration { " + "    analyticsUrl " + "    environment " + "    merchantId " + "    assetsUrl " + "    clientApiUrl " + "    creditCard { " + "      supportedCardBrands " + "      challenges " + "      threeDSecureEnabled " + "      threeDSecure { " + "        cardinalAuthenticationJWT " + "      } " + "    } " + "    applePayWeb { " + "      countryCode " + "      currencyCode " + "      merchantIdentifier " + "      supportedCardBrands " + "    } " + "    fastlane { " + "      enabled " + "      tokensOnDemand { " + "        enabled " + "        tokenExchange { " + "          enabled " + "        } " + "      } " + "    } " + "    googlePay { " + "      displayName " + "      supportedCardBrands " + "      environment " + "      googleAuthorization " + "      paypalClientId " + "    } " + "    ideal { " + "      routeId " + "      assetsUrl " + "    } " + "    masterpass { " + "      merchantCheckoutId " + "      supportedCardBrands " + "    } " + "    paypal { " + "      displayName " + "      clientId " + "      assetsUrl " + "      environment " + "      environmentNoNetwork " + "      unvettedMerchant " + "      braintreeClientId " + "      billingAgreementsEnabled " + "      merchantAccountId " + "      currencyCode " + "      payeeEmail " + "    } " + "    unionPay { " + "      merchantAccountId " + "    } " + "    usBankAccount { " + "      routeId " + "      plaidPublicKey " + "    } " + "    venmo { " + "      merchantId " + "      accessToken " + "      environment " + "      enrichedCustomerDataEnabled" + "    } " + "    visaCheckout { " + "      apiKey " + "      externalClientId " + "      supportedCardBrands " + "    } " + "    braintreeApi { " + "      accessToken " + "      url " + "    } " + "    supportedFeatures " + "  } " + "}";
      function configuration() {
        return {
          query: CONFIGURATION_QUERY,
          operationName: "ClientConfiguration"
        };
      }
      module.exports = configuration;
    }, {}],
    21: [function (_dereq_, module, exports) {
      "use strict";

      var assign = _dereq_("../../../../lib/assign").assign;
      function createMutation(config) {
        var hasAuthenticationInsight = config.hasAuthenticationInsight;
        var mutation = "mutation TokenizeCreditCardForPayPalConnect($input: TokenizeCreditCardForPayPalConnectInput!";
        if (hasAuthenticationInsight) {
          mutation += ", $authenticationInsightInput: AuthenticationInsightInput!";
        }
        mutation += ") { " + "  tokenizeCreditCardForPayPalConnect(input: $input) { " + "    clientMutationId " + "    paymentMethod { " + "      id " + "      details { " + "        ... on CreditCardDetails { " + "      bin " + "      brandCode " + "      last4 " + "      cardholderName " + "      expirationMonth" + "      expirationYear" + "      binData { " + "        prepaid " + "        healthcare " + "        debit " + "        durbinRegulated " + "        commercial " + "        payroll " + "        issuingBank " + "        countryOfIssuance " + "        productId " + "      } " + "        } " + "      } " + "    }";
        if (hasAuthenticationInsight) {
          mutation += "    authenticationInsight(input: $authenticationInsightInput) {" + "      customerAuthenticationRegulationEnvironment" + "    }";
        }
        mutation += "  } }";
        return mutation;
      }
      function createCreditCardForFastlaneTokenizationBody(body, options) {
        var creditCard = body.creditCard;
        var fastlane = creditCard.fastlane || {};
        var termsAndConditionsVersion = "fastlane" in creditCard && "termsAndConditionsVersion" in creditCard.fastlane && creditCard.fastlane.termsAndConditionsVersion;
        var termsAndConditionsCountry = "fastlane" in creditCard && "termsAndConditionsCountry" in creditCard.fastlane && creditCard.fastlane.termsAndConditionsCountry;
        var email = creditCard.email;
        var optIn = "hasBuyerConsent" in fastlane && fastlane.hasBuyerConsent;
        var shippingAddress = creditCard.shippingAddress;
        var variables = createCreditCardTokenizationBody(body, options);
        var ccpcVariables = assign({}, variables.input, {
          email: email,
          optIn: optIn,
          phone: creditCard.phone
        });
        if (termsAndConditionsVersion) {
          ccpcVariables.termsAndConditionsVersion = termsAndConditionsVersion;
        }
        if (termsAndConditionsCountry) {
          ccpcVariables.termsAndConditionsCountry = termsAndConditionsCountry;
        }
        if ("authAssertion" in fastlane) {
          ccpcVariables.authAssertion = fastlane.authAssertion;
        }
        if (shippingAddress) {
          ccpcVariables.shippingAddress = shippingAddress;
        }
        return {
          input: ccpcVariables
        };
      }
      function createCreditCardTokenizationBody(body, options) {
        var cc = body.creditCard;
        var billingAddress = cc && cc.billingAddress;
        var expDate = cc && cc.expirationDate;
        var expirationMonth = cc && (cc.expirationMonth || expDate && expDate.split("/")[0].trim());
        var expirationYear = cc && (cc.expirationYear || expDate && expDate.split("/")[1].trim());
        var variables = {
          input: {
            creditCard: {
              number: cc && cc.number,
              expirationMonth: expirationMonth,
              expirationYear: expirationYear,
              cvv: cc && cc.cvv,
              cardholderName: cc && cc.cardholderName
            },
            options: {}
          }
        };
        if (options.hasAuthenticationInsight) {
          variables.authenticationInsightInput = {
            merchantAccountId: body.merchantAccountId
          };
        }
        if (billingAddress) {
          variables.input.creditCard.billingAddress = billingAddress;
        }
        variables.input = addValidationRule(body, variables.input);
        return variables;
      }
      function addValidationRule(body, input) {
        var validate;
        if (body.creditCard && body.creditCard.options && typeof body.creditCard.options.validate === "boolean") {
          validate = body.creditCard.options.validate;
        } else if (body.authorizationFingerprint && body.tokenizationKey || body.authorizationFingerprint) {
          validate = true;
        } else if (body.tokenizationKey) {
          validate = false;
        }
        if (typeof validate === "boolean") {
          input.options = assign({
            validate: validate
          }, input.options);
        }
        return input;
      }
      function creditCardForFastlaneTokenization(body) {
        var options = {
          hasAuthenticationInsight: Boolean(body.authenticationInsight && body.merchantAccountId)
        };
        return {
          query: createMutation(options),
          variables: createCreditCardForFastlaneTokenizationBody(body, options),
          operationName: "TokenizeCreditCardForPayPalConnect"
        };
      }
      module.exports = creditCardForFastlaneTokenization;
    }, {
      "../../../../lib/assign": 32
    }],
    22: [function (_dereq_, module, exports) {
      "use strict";

      var assign = _dereq_("../../../../lib/assign").assign;
      function createMutation(config) {
        var hasAuthenticationInsight = config.hasAuthenticationInsight;
        var mutation = "mutation TokenizeCreditCard($input: TokenizeCreditCardInput!";
        if (hasAuthenticationInsight) {
          mutation += ", $authenticationInsightInput: AuthenticationInsightInput!";
        }
        mutation += ") { " + "  tokenizeCreditCard(input: $input) { " + "    token " + "    creditCard { " + "      bin " + "      brandCode " + "      last4 " + "      cardholderName " + "      expirationMonth" + "      expirationYear" + "      binData { " + "        prepaid " + "        healthcare " + "        debit " + "        durbinRegulated " + "        commercial " + "        payroll " + "        issuingBank " + "        countryOfIssuance " + "        productId " + "      } " + "    } ";
        if (hasAuthenticationInsight) {
          mutation += "    authenticationInsight(input: $authenticationInsightInput) {" + "      customerAuthenticationRegulationEnvironment" + "    }";
        }
        mutation += "  } }";
        return mutation;
      }
      function createCreditCardTokenizationBody(body, options) {
        var cc = body.creditCard;
        var billingAddress = cc && cc.billingAddress;
        var expDate = cc && cc.expirationDate;
        var expirationMonth = cc && (cc.expirationMonth || expDate && expDate.split("/")[0].trim());
        var expirationYear = cc && (cc.expirationYear || expDate && expDate.split("/")[1].trim());
        var variables = {
          input: {
            creditCard: {
              number: cc && cc.number,
              expirationMonth: expirationMonth,
              expirationYear: expirationYear,
              cvv: cc && cc.cvv,
              cardholderName: cc && cc.cardholderName
            },
            options: {}
          }
        };
        if (options.hasAuthenticationInsight) {
          variables.authenticationInsightInput = {
            merchantAccountId: body.merchantAccountId
          };
        }
        if (billingAddress) {
          variables.input.creditCard.billingAddress = billingAddress;
        }
        variables.input = addValidationRule(body, variables.input);
        return variables;
      }
      function addValidationRule(body, input) {
        var validate;
        if (body.creditCard && body.creditCard.options && typeof body.creditCard.options.validate === "boolean") {
          validate = body.creditCard.options.validate;
        } else if (body.authorizationFingerprint && body.tokenizationKey || body.authorizationFingerprint) {
          validate = true;
        } else if (body.tokenizationKey) {
          validate = false;
        }
        if (typeof validate === "boolean") {
          input.options = assign({
            validate: validate
          }, input.options);
        }
        return input;
      }
      function creditCardTokenization(body) {
        var options = {
          hasAuthenticationInsight: Boolean(body.authenticationInsight && body.merchantAccountId)
        };
        return {
          query: createMutation(options),
          variables: createCreditCardTokenizationBody(body, options),
          operationName: "TokenizeCreditCard"
        };
      }
      module.exports = creditCardTokenization;
    }, {
      "../../../../lib/assign": 32
    }],
    23: [function (_dereq_, module, exports) {
      "use strict";

      var features = {
        tokenize_credit_cards: "payment_methods/credit_cards",
        // eslint-disable-line camelcase
        configuration: "configuration"
      };
      var disallowedInputPaths = ["creditCard.options.unionPayEnrollment"];
      function GraphQL(config) {
        this._config = config.graphQL;
      }
      GraphQL.prototype.getGraphQLEndpoint = function () {
        return this._config.url;
      };
      GraphQL.prototype.isGraphQLRequest = function (url, body) {
        var featureEnabled;
        var path = this.getClientApiPath(url);
        if (!this._isGraphQLEnabled() || !path) {
          return false;
        }
        featureEnabled = this._config.features.some(function (feature) {
          return features[feature] === path;
        });
        if (containsDisallowedlistedKeys(body)) {
          return false;
        }
        return featureEnabled;
      };
      GraphQL.prototype.getClientApiPath = function (url) {
        var path;
        var clientApiPrefix = "/client_api/v1/";
        var pathParts = url.split(clientApiPrefix);
        if (pathParts.length > 1) {
          path = pathParts[1].split("?")[0];
        }
        return path;
      };
      GraphQL.prototype._isGraphQLEnabled = function () {
        return Boolean(this._config);
      };
      function containsDisallowedlistedKeys(body) {
        return disallowedInputPaths.some(function (keys) {
          var value = keys.split(".").reduce(function (accumulator, key) {
            return accumulator && accumulator[key];
          }, body);
          return value !== undefined; // eslint-disable-line no-undefined
        });
      }
      module.exports = GraphQL;
    }, {}],
    24: [function (_dereq_, module, exports) {
      "use strict";

      var BRAINTREE_VERSION = _dereq_("../../constants").BRAINTREE_VERSION;
      var assign = _dereq_("../../../lib/assign").assign;
      var snakeCaseToCamelCase = _dereq_("../../../lib/snake-case-to-camel-case");
      var isFastlaneCheckout = _dereq_("../../../lib/is-fastlane-checkout");
      var creditCardTokenizationBodyGenerator = _dereq_("./generators/credit-card-tokenization");
      var creditCardTokenizationResponseAdapter = _dereq_("./adapters/credit-card-tokenization");
      var creditCardTokenizationFastlaneResponseAdapter = _dereq_("./adapters/credit-card-tokenization-fastlane");
      var creditCardForFastlaneTokenizationBodyGenerator = _dereq_("./generators/credit-card-for-fastlane-tokenization");
      var configurationBodyGenerator = _dereq_("./generators/configuration");
      var configurationResponseAdapter = _dereq_("./adapters/configuration");
      var generators = {
        "payment_methods/credit_cards": function payment_methods_credit_cards(data, isFastlane) {
          if (isFastlane) {
            // Only want to use this generator when using the Fastlane flow
            return creditCardForFastlaneTokenizationBodyGenerator(data);
          }
          return creditCardTokenizationBodyGenerator(data);
        },
        configuration: configurationBodyGenerator
      };
      var adapters = {
        "payment_methods/credit_cards": function payment_methods_credit_cards(parsedBody, context, isFastlane) {
          if (isFastlane) {
            // Only want to use this adapter when using the Fastlane flow
            return creditCardTokenizationFastlaneResponseAdapter(parsedBody, context);
          }
          return creditCardTokenizationResponseAdapter(parsedBody, context);
        },
        configuration: configurationResponseAdapter
      };
      function GraphQLRequest(options) {
        var clientApiPath = options.graphQL.getClientApiPath(options.url);
        this._graphQL = options.graphQL;
        this._data = options.data;
        this._method = options.method;
        this._headers = options.headers;
        this._clientSdkMetadata = {
          source: options.metadata.source,
          integration: options.metadata.integration,
          sessionId: options.metadata.sessionId
        };
        this._sendAnalyticsEvent = options.sendAnalyticsEvent || Function.prototype;
        this._generator = generators[clientApiPath];
        this._adapter = adapters[clientApiPath];
        this._sendAnalyticsEvent("graphql.init");
      }
      GraphQLRequest.prototype.getUrl = function () {
        return this._graphQL.getGraphQLEndpoint();
      };
      GraphQLRequest.prototype.getBody = function () {
        var formattedBody = formatBodyKeys(this._data);
        var generatedBody = this._generator(formattedBody,
        // Since this is used for all GQL requests, we only want this if it's a Fastlane Tokenization request
        isFastlaneCheckout(this._data.creditCard));
        var body = assign({
          clientSdkMetadata: this._clientSdkMetadata
        }, generatedBody);
        return JSON.stringify(body);
      };
      GraphQLRequest.prototype.getMethod = function () {
        return "POST";
      };
      GraphQLRequest.prototype.getHeaders = function () {
        var authorization, headers;
        if (this._data.authorizationFingerprint) {
          this._sendAnalyticsEvent("graphql.authorization-fingerprint");
          authorization = this._data.authorizationFingerprint;
        } else {
          this._sendAnalyticsEvent("graphql.tokenization-key");
          authorization = this._data.tokenizationKey;
        }
        headers = {
          Authorization: "Bearer " + authorization,
          "Braintree-Version": BRAINTREE_VERSION
        };
        return assign({}, this._headers, headers);
      };
      GraphQLRequest.prototype.adaptResponseBody = function (parsedBody) {
        return this._adapter(parsedBody, this,
        // Since this is used for all GQL requests, we only want this if it's a Fastlane Checkout Tokenization request
        "creditCard" in this._data && isFastlaneCheckout(this._data.creditCard));
      };
      GraphQLRequest.prototype.determineStatus = function (httpStatus, parsedResponse) {
        var status, errorClass;
        if (httpStatus === 200) {
          errorClass = parsedResponse.errors && parsedResponse.errors[0] && parsedResponse.errors[0].extensions && parsedResponse.errors[0].extensions.errorClass;
          if (parsedResponse.data && !parsedResponse.errors) {
            status = 200;
          } else if (errorClass === "VALIDATION") {
            status = 422;
          } else if (errorClass === "AUTHORIZATION") {
            status = 403;
          } else if (errorClass === "AUTHENTICATION") {
            status = 401;
          } else if (isGraphQLError(errorClass, parsedResponse)) {
            status = 403;
          } else {
            status = 500;
          }
        } else if (!httpStatus) {
          status = 500;
        } else {
          status = httpStatus;
        }
        this._sendAnalyticsEvent("graphql.status." + httpStatus);
        this._sendAnalyticsEvent("graphql.determinedStatus." + status);
        return status;
      };
      function isGraphQLError(errorClass, parsedResponse) {
        return !errorClass && parsedResponse.errors[0].message;
      }

      /**
       * @ignore
       * This function formats the body consistently so _everything_ is camelCase.
       * @param {object} originalBody the body to format
       * @returns {object} The formatted object
       */
      function formatBodyKeys(originalBody) {
        var body = {};
        Object.keys(originalBody).forEach(function (key) {
          var camelCaseKey = snakeCaseToCamelCase(key);
          if (typeof originalBody[key] === "object") {
            body[camelCaseKey] = formatBodyKeys(originalBody[key]);
          } else if (typeof originalBody[key] === "number") {
            body[camelCaseKey] = String(originalBody[key]);
          } else {
            body[camelCaseKey] = originalBody[key];
          }
        });
        return body;
      }
      module.exports = GraphQLRequest;
    }, {
      "../../../lib/assign": 32,
      "../../../lib/is-fastlane-checkout": 42,
      "../../../lib/snake-case-to-camel-case": 48,
      "../../constants": 10,
      "./adapters/configuration": 16,
      "./adapters/credit-card-tokenization": 18,
      "./adapters/credit-card-tokenization-fastlane": 17,
      "./generators/configuration": 20,
      "./generators/credit-card-for-fastlane-tokenization": 21,
      "./generators/credit-card-tokenization": 22
    }],
    25: [function (_dereq_, module, exports) {
      "use strict";

      var once = _dereq_("../../lib/once");
      var AJAXDriver = _dereq_("./ajax-driver");
      module.exports = function (options, cb) {
        cb = once(cb || Function.prototype);
        options.method = (options.method || "GET").toUpperCase();
        options.timeout = options.timeout == null ? 60000 : options.timeout;
        options.data = options.data || {};
        AJAXDriver.request(options, cb);
      };
    }, {
      "../../lib/once": 46,
      "./ajax-driver": 14
    }],
    26: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (body) {
        try {
          body = JSON.parse(body);
        } catch (e) {
          /* ignored */
        }
        return body;
      };
    }, {}],
    27: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (method, body) {
        if (typeof method !== "string") {
          throw new Error("Method must be a string");
        }
        if (method.toLowerCase() !== "get" && body != null) {
          body = typeof body === "string" ? body : JSON.stringify(body);
        }
        return body;
      };
    }, {}],
    28: [function (_dereq_, module, exports) {
      "use strict";

      var isXHRAvailable = typeof window !== "undefined" && window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest();
      function getRequestObject() {
        return isXHRAvailable ? new window.XMLHttpRequest() : new window.XDomainRequest();
      }
      module.exports = {
        isAvailable: isXHRAvailable,
        getRequestObject: getRequestObject
      };
    }, {}],
    29: [function (_dereq_, module, exports) {
      "use strict";

      var createAuthorizationData = _dereq_("./create-authorization-data");
      var jsonClone = _dereq_("./json-clone");
      var constants = _dereq_("./constants");
      function addMetadata(configuration, data) {
        var key;
        var attrs = data ? jsonClone(data) : {};
        var authAttrs = createAuthorizationData(configuration.authorization).attrs;
        var _meta = jsonClone(configuration.analyticsMetadata);
        attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;
        for (key in attrs._meta) {
          if (attrs._meta.hasOwnProperty(key)) {
            _meta[key] = attrs._meta[key];
          }
        }
        attrs._meta = _meta;
        if (authAttrs.tokenizationKey) {
          attrs.tokenizationKey = authAttrs.tokenizationKey;
        } else {
          attrs.authorizationFingerprint = authAttrs.authorizationFingerprint;
        }
        return attrs;
      }
      function addEventMetadata(clientInstanceOrPromise) {
        var configuration = clientInstanceOrPromise.getConfiguration();
        var authAttrs = createAuthorizationData(configuration.authorization).attrs;
        var isProd = configuration.gatewayConfiguration.environment === "production";

        /* eslint-disable camelcase */
        var metadata = {
          api_integration_type: configuration.analyticsMetadata.integrationType,
          app_id: window.location.host,
          c_sdk_ver: constants.VERSION,
          component: "braintreeclientsdk",
          merchant_sdk_env: isProd ? "production" : "sandbox",
          merchant_id: configuration.gatewayConfiguration.merchantId,
          event_source: "web",
          platform: constants.PLATFORM,
          platform_version: window.navigator.userAgent,
          session_id: configuration.analyticsMetadata.sessionId,
          client_session_id: configuration.analyticsMetadata.sessionId,
          tenant_name: "braintree"
        };
        if (authAttrs.tokenizationKey) {
          metadata.tokenization_key = authAttrs.tokenizationKey;
        } else {
          metadata.auth_fingerprint = authAttrs.authorizationFingerprint;
        }
        /* eslint-enable camelcase */

        return metadata;
      }
      module.exports = {
        addMetadata: addMetadata,
        addEventMetadata: addEventMetadata
      };
    }, {
      "./constants": 34,
      "./create-authorization-data": 37,
      "./json-clone": 44
    }],
    30: [function (_dereq_, module, exports) {
      "use strict";

      var constants = _dereq_("./constants");
      var metadata = _dereq_("./add-metadata");
      var assign = _dereq_("./assign").assign;
      function sendPaypalEvent(clientInstanceOrPromise, eventName, callback) {
        return sendPaypalEventPlusFields(clientInstanceOrPromise, eventName, {}, callback);
      }
      function sendPaypalEventPlusFields(clientInstanceOrPromise, eventName, extraFields, callback) {
        var timestamp = Date.now();
        return Promise.resolve(clientInstanceOrPromise).then(function (client) {
          var request = client._request;
          var url = constants.ANALYTICS_URL;
          var qualifiedEvent = constants.ANALYTICS_PREFIX + eventName;
          var configuration = client.getConfiguration();
          var isProd = configuration.gatewayConfiguration.environment === "production";
          var data = {
            events: [],
            tracking: []
          };
          var trackingMeta = metadata.addEventMetadata(client, data);
          trackingMeta.event_name = qualifiedEvent; // eslint-disable-line camelcase
          trackingMeta.t = timestamp; // eslint-disable-line camelcase

          data.events = [{
            level: "info",
            event: qualifiedEvent,
            payload: {
              env: isProd ? "production" : "sandbox",
              timestamp: timestamp
            }
          }];
          data.tracking = [trackingMeta];
          if (extraFields && typeof extraFields === "object") {
            data.tracking = [appendExtraFieldsTo(trackingMeta, extraFields)];
          }
          return request({
            url: url,
            method: "post",
            data: data,
            timeout: constants.ANALYTICS_REQUEST_TIMEOUT_MS
          }, callback);
        }).catch(function (err) {
          if (callback) {
            callback(err);
          }
        });
      }
      function appendExtraFieldsTo(trackingMeta, extraFields) {
        var result = {};
        var allowedExtraFields = assign({}, extraFields);
        Object.keys(allowedExtraFields).forEach(function (field) {
          if (constants.ALLOWED_EXTRA_EVENT_FIELDS.indexOf(field) === -1) {
            delete allowedExtraFields[field];
          }
        });
        result = assign(trackingMeta, allowedExtraFields);
        return result;
      }
      module.exports = {
        sendEvent: sendPaypalEvent,
        sendEventPlus: sendPaypalEventPlusFields
      };
    }, {
      "./add-metadata": 29,
      "./assign": 32,
      "./constants": 34
    }],
    31: [function (_dereq_, module, exports) {
      "use strict";

      var loadScript = _dereq_("@braintree/asset-loader/load-script");
      var loadConnectScript = _dereq_("@paypal/accelerated-checkout-loader");
      module.exports = {
        loadScript: loadScript,
        loadFastlane: loadConnectScript.loadAxo
      };
    }, {
      "@braintree/asset-loader/load-script": 2,
      "@paypal/accelerated-checkout-loader": 8
    }],
    32: [function (_dereq_, module, exports) {
      "use strict";

      var assignNormalized = typeof Object.assign === "function" ? Object.assign : assignPolyfill;
      function assignPolyfill(destination) {
        var i, source, key;
        for (i = 1; i < arguments.length; i++) {
          source = arguments[i];
          for (key in source) {
            if (source.hasOwnProperty(key)) {
              destination[key] = source[key];
            }
          }
        }
        return destination;
      }
      module.exports = {
        assign: assignNormalized,
        _assign: assignPolyfill
      };
    }, {}],
    33: [function (_dereq_, module, exports) {
      "use strict";

      var enumerate = _dereq_("./enumerate");

      /**
       * @class
       * @global
       * @param {object} options Construction options
       * @classdesc This class is used to report error conditions, frequently as the first parameter to callbacks throughout the Braintree SDK.
       * @description <strong>You cannot use this constructor directly. Interact with instances of this class through {@link callback callbacks}.</strong>
       */
      function BraintreeError(options) {
        if (!BraintreeError.types.hasOwnProperty(options.type)) {
          throw new Error(options.type + " is not a valid type.");
        }
        if (!options.code) {
          throw new Error("Error code required.");
        }
        if (!options.message) {
          throw new Error("Error message required.");
        }
        this.name = "BraintreeError";

        /**
         * @type {string}
         * @description A code that corresponds to specific errors.
         */
        this.code = options.code;

        /**
         * @type {string}
         * @description A short description of the error.
         */
        this.message = options.message;

        /**
         * @type {BraintreeError.types}
         * @description The type of error.
         */
        this.type = options.type;

        /**
         * @type {object=}
         * @description Additional information about the error, such as an underlying network error response.
         */
        this.details = options.details;
      }
      BraintreeError.prototype = Object.create(Error.prototype);
      BraintreeError.prototype.constructor = BraintreeError;

      /**
       * Enum for {@link BraintreeError} types.
       * @name BraintreeError.types
       * @enum
       * @readonly
       * @memberof BraintreeError
       * @property {string} CUSTOMER An error caused by the customer.
       * @property {string} MERCHANT An error that is actionable by the merchant.
       * @property {string} NETWORK An error due to a network problem.
       * @property {string} INTERNAL An error caused by Braintree code.
       * @property {string} UNKNOWN An error where the origin is unknown.
       */
      BraintreeError.types = enumerate(["CUSTOMER", "MERCHANT", "NETWORK", "INTERNAL", "UNKNOWN"]);
      BraintreeError.findRootError = function (err) {
        if (err instanceof BraintreeError && err.details && err.details.originalError) {
          return BraintreeError.findRootError(err.details.originalError);
        }
        return err;
      };
      module.exports = BraintreeError;
    }, {
      "./enumerate": 39
    }],
    34: [function (_dereq_, module, exports) {
      "use strict";

      var VERSION = "3.118.2";
      var PLATFORM = "web";
      var CLIENT_API_URLS = {
        production: "https://api.braintreegateway.com:443",
        sandbox: "https://api.sandbox.braintreegateway.com:443"
      };
      var ASSETS_URLS = {
        production: "https://assets.braintreegateway.com",
        sandbox: "https://assets.braintreegateway.com"
      };
      var GRAPHQL_URLS = {
        production: "https://payments.braintree-api.com/graphql",
        sandbox: "https://payments.sandbox.braintree-api.com/graphql"
      };

      // endRemoveIf(production)

      module.exports = {
        ANALYTICS_PREFIX: PLATFORM + ".",
        ANALYTICS_REQUEST_TIMEOUT_MS: 2000,
        ANALYTICS_URL: "https://www.paypal.com/xoplatform/logger/api/logger",
        ASSETS_URLS: ASSETS_URLS,
        CLIENT_API_URLS: CLIENT_API_URLS,
        FRAUDNET_SOURCE: "BRAINTREE_SIGNIN",
        FRAUDNET_FNCLS: "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99",
        FRAUDNET_URL: "https://c.paypal.com/da/r/fb.js",
        BUS_CONFIGURATION_REQUEST_EVENT: "BUS_CONFIGURATION_REQUEST",
        GRAPHQL_URLS: GRAPHQL_URLS,
        INTEGRATION_TIMEOUT_MS: 60000,
        VERSION: VERSION,
        INTEGRATION: "custom",
        SOURCE: "client",
        PLATFORM: PLATFORM,
        BRAINTREE_LIBRARY_VERSION: "braintree/" + PLATFORM + "/" + VERSION,
        ALLOWED_EXTRA_EVENT_FIELDS: ["paypal_context_id"]
      };
    }, {}],
    35: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("./braintree-error");
      var sharedErrors = _dereq_("./errors");
      module.exports = function (instance, methodNames) {
        methodNames.forEach(function (methodName) {
          instance[methodName] = function () {
            throw new BraintreeError({
              type: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.type,
              code: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.code,
              message: methodName + " cannot be called after teardown."
            });
          };
        });
      };
    }, {
      "./braintree-error": 33,
      "./errors": 40
    }],
    36: [function (_dereq_, module, exports) {
      "use strict";

      var BraintreeError = _dereq_("./braintree-error");
      function convertToBraintreeError(originalErr, btErrorObject) {
        if (originalErr instanceof BraintreeError) {
          return originalErr;
        }
        return new BraintreeError({
          type: btErrorObject.type,
          code: btErrorObject.code,
          message: btErrorObject.message,
          details: {
            originalError: originalErr
          }
        });
      }
      module.exports = convertToBraintreeError;
    }, {
      "./braintree-error": 33
    }],
    37: [function (_dereq_, module, exports) {
      "use strict";

      var atob = _dereq_("../lib/vendor/polyfill").atob;
      var CLIENT_API_URLS = _dereq_("../lib/constants").CLIENT_API_URLS;
      function _isTokenizationKey(str) {
        return /^[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9_]+$/.test(str);
      }
      function _parseTokenizationKey(tokenizationKey) {
        var tokens = tokenizationKey.split("_");
        var environment = tokens[0];
        var merchantId = tokens.slice(2).join("_");
        return {
          merchantId: merchantId,
          environment: environment
        };
      }
      function createAuthorizationData(authorization) {
        var parsedClientToken, parsedTokenizationKey;
        var data = {
          attrs: {},
          configUrl: ""
        };
        if (_isTokenizationKey(authorization)) {
          parsedTokenizationKey = _parseTokenizationKey(authorization);
          data.environment = parsedTokenizationKey.environment;
          data.attrs.tokenizationKey = authorization;
          data.configUrl = CLIENT_API_URLS[parsedTokenizationKey.environment] + "/merchants/" + parsedTokenizationKey.merchantId + "/client_api/v1/configuration";
        } else {
          parsedClientToken = JSON.parse(atob(authorization));
          data.environment = parsedClientToken.environment;
          data.attrs.authorizationFingerprint = parsedClientToken.authorizationFingerprint;
          data.configUrl = parsedClientToken.configUrl;
          data.graphQL = parsedClientToken.graphQL;
        }
        return data;
      }
      module.exports = createAuthorizationData;
    }, {
      "../lib/constants": 34,
      "../lib/vendor/polyfill": 49
    }],
    38: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (fn) {
        return function () {
          // IE9 doesn't support passing arguments to setTimeout so we have to emulate it.
          var args = arguments;
          setTimeout(function () {
            fn.apply(null, args);
          }, 1);
        };
      };
    }, {}],
    39: [function (_dereq_, module, exports) {
      "use strict";

      function enumerate(values, prefix) {
        prefix = prefix == null ? "" : prefix;
        return values.reduce(function (enumeration, value) {
          enumeration[value] = prefix + value;
          return enumeration;
        }, {});
      }
      module.exports = enumerate;
    }, {}],
    40: [function (_dereq_, module, exports) {
      "use strict";

      /**
       * @name BraintreeError.Shared Internal Error Codes
       * @ignore
       * @description These codes should never be experienced by the merchant directly.
       * @property {INTERNAL} INVALID_USE_OF_INTERNAL_FUNCTION Occurs when the client is created without a gateway configuration. Should never happen.
       */

      /**
       * @name BraintreeError.Shared Errors - Component Creation Error Codes
       * @description Errors that occur when creating components.
       * @property {MERCHANT} INSTANTIATION_OPTION_REQUIRED Occurs when a component is created that is missing a required option.
       * @property {MERCHANT} INCOMPATIBLE_VERSIONS Occurs when a component is created with a client with a different version than the component.
       * @property {NETWORK} CLIENT_SCRIPT_FAILED_TO_LOAD Occurs when a component attempts to load the Braintree client script, but the request fails.
       */

      /**
       * @name BraintreeError.Shared Errors - Component Instance Error Codes
       * @description Errors that occur when using instances of components.
       * @property {MERCHANT} METHOD_CALLED_AFTER_TEARDOWN Occurs when a method is called on a component instance after it has been torn down.
       */
      var BraintreeError = _dereq_("./braintree-error");
      module.exports = {
        INVALID_USE_OF_INTERNAL_FUNCTION: {
          type: BraintreeError.types.INTERNAL,
          code: "INVALID_USE_OF_INTERNAL_FUNCTION"
        },
        INSTANTIATION_OPTION_REQUIRED: {
          type: BraintreeError.types.MERCHANT,
          code: "INSTANTIATION_OPTION_REQUIRED"
        },
        INCOMPATIBLE_VERSIONS: {
          type: BraintreeError.types.MERCHANT,
          code: "INCOMPATIBLE_VERSIONS"
        },
        CLIENT_SCRIPT_FAILED_TO_LOAD: {
          type: BraintreeError.types.NETWORK,
          code: "CLIENT_SCRIPT_FAILED_TO_LOAD",
          message: "Braintree client script could not be loaded."
        },
        METHOD_CALLED_AFTER_TEARDOWN: {
          type: BraintreeError.types.MERCHANT,
          code: "METHOD_CALLED_AFTER_TEARDOWN"
        }
      };
    }, {
      "./braintree-error": 33
    }],
    41: [function (_dereq_, module, exports) {
      "use strict";

      function convertDateStringToDate(dateString) {
        var splitDate = dateString.split("-");
        return new Date(splitDate[0], splitDate[1], splitDate[2]);
      }
      function isDateStringBeforeOrOn(firstDate, secondDate) {
        return convertDateStringToDate(firstDate) <= convertDateStringToDate(secondDate);
      }
      module.exports = isDateStringBeforeOrOn;
    }, {}],
    42: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (creditCardDetails) {
        return creditCardDetails && creditCardDetails.hasOwnProperty("fastlane") && creditCardDetails.fastlane;
      };
    }, {}],
    43: [function (_dereq_, module, exports) {
      "use strict";

      var parser;
      var legalHosts = {
        "paypal.com": 1,
        "braintreepayments.com": 1,
        "braintreegateway.com": 1,
        "braintree-api.com": 1
      };

      // endRemoveIf(production)

      function stripSubdomains(domain) {
        return domain.split(".").slice(-2).join(".");
      }
      function isVerifiedDomain(url) {
        var mainDomain;
        url = url.toLowerCase();
        if (!/^https:/.test(url)) {
          return false;
        }
        parser = parser || document.createElement("a");
        parser.href = url;
        mainDomain = stripSubdomains(parser.hostname);
        return legalHosts.hasOwnProperty(mainDomain);
      }
      module.exports = isVerifiedDomain;
    }, {}],
    44: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (value) {
        return JSON.parse(JSON.stringify(value));
      };
    }, {}],
    45: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (obj) {
        return Object.keys(obj).filter(function (key) {
          return typeof obj[key] === "function";
        });
      };
    }, {}],
    46: [function (_dereq_, module, exports) {
      "use strict";

      function once(fn) {
        var called = false;
        return function () {
          if (!called) {
            called = true;
            fn.apply(null, arguments);
          }
        };
      }
      module.exports = once;
    }, {}],
    47: [function (_dereq_, module, exports) {
      "use strict";

      function _notEmpty(obj) {
        var key;
        for (key in obj) {
          if (obj.hasOwnProperty(key)) {
            return true;
          }
        }
        return false;
      }

      /* eslint-disable no-mixed-operators */
      function _isArray(value) {
        return value && typeof value === "object" && typeof value.length === "number" && Object.prototype.toString.call(value) === "[object Array]" || false;
      }
      /* eslint-enable no-mixed-operators */

      function hasQueryParams(url) {
        url = url || window.location.href;
        return /\?/.test(url);
      }
      function parse(url) {
        var query, params;
        url = url || window.location.href;
        if (!hasQueryParams(url)) {
          return {};
        }
        query = url.split("?")[1] || "";
        query = query.replace(/#.*$/, "").split("&");
        params = query.reduce(function (toReturn, keyValue) {
          var parts = keyValue.split("=");
          var key = decodeURIComponent(parts[0]);
          var value = decodeURIComponent(parts[1]);
          toReturn[key] = value;
          return toReturn;
        }, {});
        return params;
      }
      function stringify(params, namespace) {
        var k, v, p;
        var query = [];
        for (p in params) {
          if (!params.hasOwnProperty(p)) {
            continue;
          }
          v = params[p];
          if (namespace) {
            if (_isArray(params)) {
              k = namespace + "[]";
            } else {
              k = namespace + "[" + p + "]";
            }
          } else {
            k = p;
          }
          if (typeof v === "object") {
            query.push(stringify(v, k));
          } else {
            query.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
          }
        }
        return query.join("&");
      }
      function queryify(url, params) {
        url = url || "";
        if (params != null && typeof params === "object" && _notEmpty(params)) {
          url += url.indexOf("?") === -1 ? "?" : "";
          url += url.indexOf("=") !== -1 ? "&" : "";
          url += stringify(params);
        }
        return url;
      }
      module.exports = {
        parse: parse,
        stringify: stringify,
        queryify: queryify,
        hasQueryParams: hasQueryParams
      };
    }, {}],
    48: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (snakeString) {
        if (snakeString.indexOf("_") === -1) {
          return snakeString;
        }
        return snakeString.toLowerCase().replace(/(\_\w)/g, function (match) {
          return match[1].toUpperCase();
        });
      };
    }, {}],
    49: [function (_dereq_, module, exports) {
      "use strict";

      // NEXT_MAJOR_VERSION old versions of IE don't have atob, in the
      // next major version, we're dropping support for those versions
      // so we can eliminate the need to have this atob polyfill
      var atobNormalized = typeof atob === "function" ? atob : atobPolyfill;
      function atobPolyfill(base64String) {
        var a, b, c, b1, b2, b3, b4, i;
        var base64Matcher = new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$");
        var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var result = "";
        if (!base64Matcher.test(base64String)) {
          throw new Error("Non base64 encoded input passed to window.atob polyfill");
        }
        i = 0;
        do {
          b1 = characters.indexOf(base64String.charAt(i++));
          b2 = characters.indexOf(base64String.charAt(i++));
          b3 = characters.indexOf(base64String.charAt(i++));
          b4 = characters.indexOf(base64String.charAt(i++));
          a = (b1 & 0x3f) << 2 | b2 >> 4 & 0x3;
          b = (b2 & 0xf) << 4 | b3 >> 2 & 0xf;
          c = (b3 & 0x3) << 6 | b4 & 0x3f;
          result += String.fromCharCode(a) + (b ? String.fromCharCode(b) : "") + (c ? String.fromCharCode(c) : "");
        } while (i < base64String.length);
        return result;
      }
      module.exports = {
        atob: function atob(base64String) {
          return atobNormalized.call(window, base64String);
        },
        _atob: atobPolyfill
      };
    }, {}]
  }, {}, [13])(13);
});